/**
 * Uses MutationObserver to watch for added elements
 *
 * @param {String | Element} child
 * @param {Function} callback
 * @param {String} parent
 *
 * @usage
 *  $('.element-to-watch-within').watchFor('.element-to-watch-for', function($el) {
      this.onElementRender($el);
  });
*/
$.fn.watchFor = function (child, callback) {
  const parent = this[0];

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (addedNode) {
        const $foundNodes = $(addedNode).find(child);

        if ($foundNodes.length && callback) callback($foundNodes);
      });
    });
  });
  observer.observe(parent, { subtree: true, childList: true });

  if (callback) callback($(child));

  return this;
};

(function () {
  var Accordion,
    FullscreenSlider,
    HorizontalTabs,
    Main,
    Popup,
    ProductSlider,
    VerticalTabs,
    VideoModal,
    bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
    extend = function (child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    hasProp = {}.hasOwnProperty;

  theme.classes.FrameworkArticle = (function () {
    function FrameworkArticle(root) {
      var _this;
      this.root = root;
      this.initializeDisqus = bind(this.initializeDisqus, this);
      this.hideTagInfo = bind(this.hideTagInfo, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.comments_enabled = _this.root.data("comments-enabled");
      _this.disqus_shortname = _this.root.attr("data-disqus-shortname");
      _this.enable_disqus = _this.root.data("enable-disqus");
      _this.no_tags_displayed =
        _this.root.find(".article--tag").length === 0 ? true : false;
      _this.load();
    }

    FrameworkArticle.prototype.load = function () {
      var _this;
      _this = this;
      if (_this.no_tags_displayed) {
        _this.hideTagInfo();
      }
      if (_this.enable_disqus && _this.comments_enabled) {
        return _this.initializeDisqus();
      }
    };

    FrameworkArticle.prototype.hideTagInfo = function () {
      var _this;
      _this = this;
      return _this.root.find(".article--tag-info").hide();
    };

    FrameworkArticle.prototype.initializeDisqus = function () {
      var _this;
      _this = this;
      return theme.utils.insertScript(
        "https://" + _this.disqus_shortname + ".disqus.com/embed.js"
      );
    };

    return FrameworkArticle;
  })();

  theme.classes.FrameworkBlog = (function () {
    function FrameworkBlog(root) {
      var _this, enable_masonry;
      this.root = root;
      this.initMasonry = bind(this.initMasonry, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.list = _this.root.find(".blog--list");
      enable_masonry = _this.root.data("columns") !== 1;
      if (enable_masonry) {
        _this.load();
      }
    }

    FrameworkBlog.prototype.load = function () {
      var _this;
      _this = this;
      return theme.utils.insertScript(theme.assets.masonry, function () {
        if (theme.utils.mqs.current_window !== "small") {
          _this.initMasonry();
        }
        return _this.eventListeners();
      });
    };

    FrameworkBlog.prototype.eventListeners = function () {
      var _this;
      _this = this;
      return $(window).on("theme.utils.mqs.updated", function () {
        var masonry_loaded;
        masonry_loaded = _this.list.data("masonry") ? true : false;
        if (!(theme.utils.mqs.current_window === "small" || masonry_loaded)) {
          return _this.initMasonry();
        } else if (
          theme.utils.mqs.current_window === "small" &&
          masonry_loaded
        ) {
          return _this.list.masonry("destroy");
        }
      });
    };

    FrameworkBlog.prototype.initMasonry = function () {
      var _this;
      _this = this;
      return _this.list.masonry({
        itemSelector: ".blog--list--item",
        percentPosition: true,
        horizontalOrder: true,
        columnWidth: ".blog--list--item",
      });
    };

    return FrameworkBlog;
  })();

  theme.classes.FrameworkCart = (function () {
    function FrameworkCart(root) {
      var _this;
      this.root = root;
      this.renderDynamicCheckoutButtons = bind(
        this.renderDynamicCheckoutButtons,
        this
      );
      this.updateTotals = bind(this.updateTotals, this);
      this.updateAllHasItems = bind(this.updateAllHasItems, this);
      this.addItem = bind(this.addItem, this);
      this.swapInImages = bind(this.swapInImages, this);
      this.getHtml = bind(this.getHtml, this);
      this.updateHtml = bind(this.updateHtml, this);
      this.htmlListener = bind(this.htmlListener, this);
      this.updateAllHtml = bind(this.updateAllHtml, this);
      this.updateNote = bind(this.updateNote, this);
      this.noteTypingListener = bind(this.noteTypingListener, this);
      this.updateQuantity = bind(this.updateQuantity, this);
      this.clearRequests = bind(this.clearRequests, this);
      this.toggleLoadingDisplay = bind(this.toggleLoadingDisplay, this);
      this.removeItem = bind(this.removeItem, this);
      this.removeButtonListener = bind(this.removeButtonListener, this);
      this.minusButtonListener = bind(this.minusButtonListener, this);
      this.plusButtonListener = bind(this.plusButtonListener, this);
      this.inputBoxListener = bind(this.inputBoxListener, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.getAjaxUrl = bind(this.getAjaxUrl, this);
      this.getOtherCarts = bind(this.getOtherCarts, this);
      _this = this;
      _this.other_carts = _this.getOtherCarts();
      _this.quantity_request = {};
      _this.quantity_timer = {};
      _this.total_item_count = $(".cart--external--total-items");
      _this.total_price = $(".cart--external--total-price");
      _this.view = _this.root.attr("data-view");
      _this.getAjaxUrl();
      _this.updateTotals();
      _this.htmlListener();
      _this.eventListeners();
      _this.renderDynamicCheckoutButtons();
    }

    FrameworkCart.prototype.getOtherCarts = function () {
      var _this, other_carts;
      _this = this;
      return (other_carts = $('[data-js-class="Cart"]').not(_this.root));
    };

    FrameworkCart.prototype.getAjaxUrl = function () {
      var _this;
      _this = this;
      _this.ajax_url = window.location.href;
      _this.ajax_url = _this.ajax_url.replace(
        window.location.hostname + window.location.pathname,
        window.location.hostname + theme.urls.cart
      );
      _this.ajax_url = _this.ajax_url.replace("#", "");
      if (_this.ajax_url.indexOf("?") >= 0) {
        _this.ajax_url = _this.ajax_url + "&";
      } else {
        _this.ajax_url = _this.ajax_url + "?";
      }
      _this.ajax_desktop_url = _this.ajax_url + "view=ajax--desktop";
      return (_this.ajax_mobile_url = _this.ajax_url + "view=ajax--mobile");
    };

    FrameworkCart.prototype.eventListeners = function () {
      var _this;
      _this = this;
      _this.inputBoxListener();
      _this.plusButtonListener();
      _this.minusButtonListener();
      _this.removeButtonListener();
      return _this.noteTypingListener();
    };

    FrameworkCart.prototype.inputBoxListener = function () {
      var _this, input_box;
      _this = this;
      input_box = _this.root.find(".cart--quantity--input");
      input_box.on("keydown", function (event) {
        if (
          (event.which < 48 || event.which > 57) &&
          event.which !== 8 &&
          event.which !== 37 &&
          event.which !== 39 &&
          event.which !== 9
        ) {
          return event.preventDefault();
        }
      });
      return input_box.on("focusout", function (event) {
        var item_key, quantity;
        item_key = $(this).closest(".cart--item").data("item-key");
        _this.toggleLoadingDisplay(item_key);
        _this.clearRequests(item_key);
        quantity = theme.utils.isNaN(parseInt($(this).val()))
          ? 1
          : parseInt($(this).val());
        if (quantity === 0) {
          return _this.removeItem(item_key);
        } else {
          return _this.updateQuantity(
            item_key,
            quantity,
            0,
            function (success) {
              if (success) {
                return _this.updateAllHtml(function () { });
              }
            }
          );
        }
      });
    };

    FrameworkCart.prototype.plusButtonListener = function () {
      var _this, plus_button;
      _this = this;
      plus_button = _this.root.find(".cart--item--quantity .plus");
      return plus_button.on("click", function () {
        var input, item_key, quantity;
        input = $(this).prev("input");
        item_key = $(this).closest(".cart--item").data("item-key");
        quantity = theme.utils.isNaN(parseInt(input.val()))
          ? 1
          : parseInt(input.val()) + 1;
        input.val(quantity);
        _this.toggleLoadingDisplay(item_key);
        _this.clearRequests(item_key);
        _this.updateQuantity(item_key, quantity, 700, function (success) {
          if (success) {
            return _this.updateAllHtml(function () { });
          }
        });
        return false;
      });
    };

    FrameworkCart.prototype.minusButtonListener = function () {
      var _this, minus_button;
      _this = this;
      minus_button = _this.root.find(".cart--item--quantity .minus");
      return minus_button.on("click", function () {
        var input, item_key, quantity;
        input = $(this).siblings("input");
        item_key = $(this).closest(".cart--item").data("item-key");
        quantity = theme.utils.isNaN(parseInt(input.val()))
          ? 1
          : parseInt(input.val()) - 1;
        if (quantity < 1) {
          quantity = 1;
        }
        input.val(quantity);
        _this.toggleLoadingDisplay(item_key);
        _this.clearRequests(item_key);
        _this.updateQuantity(item_key, quantity, 700, function (success) {
          if (success) {
            return _this.updateAllHtml(function () { });
          }
        });
        return false;
      });
    };

    FrameworkCart.prototype.removeButtonListener = function () {
      var _this, remove_button;
      _this = this;
      remove_button = _this.root.find(".cart--item--remove");
      return remove_button.on("click", function () {
        var item_key;
        item_key = $(this).closest(".cart--item").data("item-key");
        _this.toggleLoadingDisplay(item_key);
        _this.clearRequests(item_key);
        _this.removeItem(item_key);
        return false;
      });
    };

    FrameworkCart.prototype.removeItem = function (item_key) {
      var _this;
      _this = this;
      return _this.updateQuantity(item_key, 0, 0, function (success) {
        if (success) {
          return _this.updateAllHtml(function () { });
        }
      });
    };

    FrameworkCart.prototype.toggleLoadingDisplay = function (item_key) {
      var _this, checkout_button, input;
      _this = this;
      input = _this.root.find(
        ".cart--item[data-item-key='" + item_key + "'] input"
      );
      input.attr("data-loading", "true");
      checkout_button = _this.root.find(".cart--checkout-button button");
      checkout_button.attr("disabled", true);
      return _this.root
        .find(".cart--additional-buttons")
        .css("visibility", "hidden");
    };

    FrameworkCart.prototype.clearRequests = function (item_key) {
      var _this;
      _this = this;
      if (_this.quantity_request.item_key) {
        _this.quantity_request.item_key.abort();
      }
      if (_this.quantity_timer.item_key) {
        return clearTimeout(_this.quantity_timer.item_key);
      }
    };

    FrameworkCart.prototype.updateQuantity = function (
      item_key,
      quantity,
      time_out,
      callback
    ) {
      var _this, ajaxQuantity;
      _this = this;
      ajaxQuantity = function () {
        return (_this.quantity_request.item_key = $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: "quantity=" + quantity + "&id=" + item_key,
        })
          .done(function (data, textStatus, jqXHR) {
            callback(true);
            return _this.updateTotals();
          })
          .fail(function (jqXHR, textStatus) {
            if (jqXHR.responseText) {
              console.log(
                "Error - ajax update quantity",
                JSON.parse(jqXHR.responseText).description
              );
            }
            return callback(false);
          }));
      };
      return (_this.quantity_timer.item_key = setTimeout(
        ajaxQuantity,
        time_out
      ));
    };

    FrameworkCart.prototype.noteTypingListener = function () {
      var _this, note_textbox;
      _this = this;
      note_textbox = _this.root.find(".cart--notes--textarea");
      return note_textbox.on("input", function () {
        if (_this.note_request) {
          _this.note_request.abort();
        }
        if (_this.note_timer) {
          clearTimeout(_this.note_timer);
        }
        return _this.updateNote($(this).val());
      });
    };

    FrameworkCart.prototype.updateNote = function (note) {
      var _this, ajaxNote;
      _this = this;
      ajaxNote = function () {
        return (_this.note_request = $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: {
            note: note,
          },
        })
          .done(function () {
            return _this.other_carts.trigger("update-html");
          })
          .fail(function (jqXHR, textStatus) {
            if (jqXHR.responseText) {
              return console.log(
                "Error - ajax update note",
                JSON.parse(jqXHR.responseText).description
              );
            }
          }));
      };
      return (_this.note_timer = setTimeout(ajaxNote, 350));
    };

    FrameworkCart.prototype.updateAllHtml = function (update_all_html_done) {
      var _this;
      _this = this;
      _this.updateHtml(update_all_html_done);
      return _this.other_carts.trigger("update-html");
    };

    FrameworkCart.prototype.htmlListener = function () {
      var _this;
      _this = this;
      return _this.root.on("update-html", function () {
        return _this.updateHtml(function () { });
      });
    };

    FrameworkCart.prototype.updateHtml = function (update_all_html_done) {
      var _this;
      _this = this;
      return _this.getHtml(_this.view, function (new_html) {
        var new_form, old_form;
        old_form = _this.root.find(".cart--form");
        new_form = new_html.find(".cart--form");
        new_form = _this.swapInImages(old_form, new_form);
        old_form.replaceWith(new_form);
        _this.eventListeners();
        update_all_html_done();
        return $(window).trigger("theme.cart.update-complete");
      });
    };

    FrameworkCart.prototype.getHtml = function (view, callback) {
      var _this, url;
      _this = this;
      url = _this.ajax_desktop_url;
      if (view === "mobile") {
        url = _this.ajax_mobile_url;
      }
      return $.ajax({
        url: url,
        type: "GET",
        dataType: "html",
      })
        .done(function (data) {
          var cart_html;
          cart_html = $($.parseHTML(data));
          callback(cart_html);
        })
        .fail(function (jqxhr, textStatus, error) {
          console.log(
            "search.json Request Failed: " + textStatus + ", " + error
          );
          callback(false);
        });
    };

    FrameworkCart.prototype.swapInImages = function (old_html, new_html) {
      var _this, new_items;
      _this = this;
      new_items = new_html.find(".cart--item");
      new_items.each(function () {
        var new_image, new_instance, old_image, old_item, variant_id;
        variant_id = $(this).attr("data-variant-id");
        new_image = $(this).find(".cart--item--image");
        new_instance = new_html
          .find("[data-variant-id='" + variant_id + "'] .cart--item--image")
          .index(new_image);
        old_item = old_html
          .find("[data-variant-id='" + variant_id + "']")
          .eq(new_instance);
        if (old_item.length > 0) {
          old_image = old_item.find(".cart--item--image");
          return new_image.replaceWith(old_image);
        }
      });
      return new_html;
    };

    FrameworkCart.prototype.addItem = function (form, callback) {
      var _this;
      _this = this;
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: form.serialize(),
      })
        .done(function (data, textStatus, jqXHR) {
          callback(true);
          _this.updateAllHasItems(1, true);
          return _this.updateTotals();
        })
        .fail(function (jqXHR, textStatus) {
          console.log(
            "Error - ajax update quantity",
            JSON.parse(jqXHR.responseText).description
          );
          return callback(false, JSON.parse(jqXHR.responseText).description);
        });
    };

    FrameworkCart.prototype.updateAllHasItems = function (
      item_count,
      force_true
    ) {
      var _this, has_items;
      if (force_true == null) {
        force_true = false;
      }
      _this = this;
      has_items = false;
      if (item_count > 0 || force_true) {
        has_items = true;
      }
      _this.root.attr("data-has-items", has_items);
      return _this.other_carts.attr("data-has-items", has_items);
    };

    FrameworkCart.prototype.updateTotals = function () {
      var _this;
      _this = this;
      return $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
      })
        .done(function (data, textStatus, jqXHR) {
          var count, total_price;
          total_price = theme.utils.formatMoney(data.total_price);
          count = data.item_count;
          _this.updateAllHasItems(count);
          _this.total_price.html(total_price);
          _this.total_item_count.text(count);
          return _this.updateTotalsComplete(count);
        })
        .fail(function (jqXHR, textStatus) {
          return console.log(
            "Error - ajax updating totals",
            JSON.parse(jqXHR.responseText).description
          );
        });
    };

    FrameworkCart.prototype.renderDynamicCheckoutButtons = function () {
      var _this;
      _this = this;
      if (window.location.pathname === theme.urls.cart) {
        $(".off-canvas--right-sidebar .cart--additional-buttons").remove();
        if (theme.utils.mqs.current_window === "small") {
          return $('[data-view="desktop"] .cart--additional-buttons').remove();
        }
      }
    };

    return FrameworkCart;
  })();

  theme.classes.FrameworkDisclosure = (function () {
    function FrameworkDisclosure(root) {
      var _this;
      this.root = root;
      this.optionChangeCallback = bind(this.optionChangeCallback, this);
      this.configureFormDisplay = bind(this.configureFormDisplay, this);
      this.toggleFormDisplay = bind(this.toggleFormDisplay, this);
      this.setOptionOnClick = bind(this.setOptionOnClick, this);
      this.hideFormWhenFocusOut = bind(this.hideFormWhenFocusOut, this);
      this.showFormWhenClick = bind(this.showFormWhenClick, this);
      this.resizeListener = bind(this.resizeListener, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_option = _this.root.find(".disclosure--current-option");
      _this.form = _this.root.find(".disclosure--form");
      _this.input = _this.root.find('[data-item="disclosure"]');
      _this.links = _this.root.find(".disclosure--option-link");
      _this.toggle = _this.root.find(".disclosure--toggle");
      _this.type = _this.root.attr("data-type");
      _this.toggle_and_form_gap = 8;
      _this.window_and_form_gap = 32;
      _this.form_space_needed =
        _this.form.height() +
        _this.toggle_and_form_gap +
        _this.window_and_form_gap;
      _this.load();
    }

    FrameworkDisclosure.prototype.load = function () {
      var _this;
      _this = this;

      _this.resizeListener();
      _this.showFormWhenClick();
      _this.hideFormWhenFocusOut();
      _this.input.on("change", _this.handleInputChange);
      _this.input.trigger("change");
      _this.setOptionOnClick();
      _this.configureFormDisplay();
      if (_this.type === "url-redirect" || _this.type === "localization") {
        return _this.optionChangeCallback();
      }
    };

    FrameworkDisclosure.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize",
        theme.utils.debounce(100, function () {
          return _this.configureFormDisplay();
        })
      );
    };

    FrameworkDisclosure.prototype.showFormWhenClick = function () {
      var _this;
      _this = this;
      return _this.toggle.on("click keydown", function (event) {
        var aria_expanded;

        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        aria_expanded = $(this).attr("aria-expanded") === "true";
        return _this.toggleFormDisplay(!aria_expanded);
      });
    };

    FrameworkDisclosure.prototype.hideFormWhenFocusOut = function () {
      var _this;
      _this = this;
      _this.toggle.on("focusout", function (event) {
        var form_lost_focus;
        form_lost_focus = _this.root.has(event.relatedTarget).length === 0;
        if (form_lost_focus) {
          return _this.toggleFormDisplay(false);
        }
      });
      _this.form.on("focusout", function (event) {
        var child_in_focus, is_visible;
        child_in_focus = $(this).has(event.relatedTarget).length > 0;
        is_visible = _this.toggle.attr("aria-expanded") === "true";
        if (is_visible && !child_in_focus) {
          return _this.toggleFormDisplay(false);
        }
      });
      return _this.root.on("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        _this.toggleFormDisplay(false);
        return _this.toggle.focus();
      });
    };

    FrameworkDisclosure.prototype.handleInputChange = function (e) {
      let $this = $(this);
      let $parentForm = $this.parents('form[action="/cart/add"]');
      let $disclosureOptions = $parentForm.find(".disclosure--option");
      let $select = $parentForm.find(".js-disclosure-select");
      let $options = $select.children("option");
      let value = $this.val();
      let newOptionVal;
      let newOptionPrice;
      let newOptionAvailability;
      let $variantPriceWrapper = $parentForm.siblings("[data-price-wrapper]");
      let $variantPriceElement = $variantPriceWrapper.find(
        "[data-variant-price]"
      );

      $options.each(function (i, el) {
        let optVal = $(el).data("title");
        if (optVal === value) {
          newOptionVal = $(el).val();
          newOptionPrice = $(el).data("price") ? $(el).data("price").replace('.00', '') : '';
          newOptionAvailability = $(el).data("availability");
        }
      });

      let $collectionPageBISTrigger = $parentForm.find(
        "[data-back-in-stock-collection-entry]"
      );

      if (!!$collectionPageBISTrigger && $collectionPageBISTrigger.length > 0) {
        let $bisWrapper = $collectionPageBISTrigger.parent("[data-back-in-stock-wrapper]")
        let $atcButton = $parentForm.find('.product-form--add-to-cart');
        let oosText = 'Sold Out';
        // let atcText = newOptionPrice ? `${newOptionPrice} | Add to Cart` : 'Add to Cart';
        let atcHTML = newOptionPrice
          ? `<span class="tw-text-base tw-font-normal">Quick Add</span><span class="tw-text-base tw-font-semibold tw-pl-3">${newOptionPrice}</span>`
          : '<span class="tw-text-base tw-font-normal">Quick Add</span>';

        if (!!newOptionAvailability) {
          // available, hide BIS, 'Add to Cart'
          $bisWrapper.hide()
          $collectionPageBISTrigger.hide();
          $atcButton.prop('disabled', false);
          // $atcButton.text(atcText);
          $atcButton.html(atcHTML);

        } else {
          // unavailable, show BIS, 'Sold Out'
          $bisWrapper.show()
          $collectionPageBISTrigger.show();
          $atcButton.prop('disabled', true);
          $atcButton.text(oosText);
        }
      }

      $select.val(newOptionVal).trigger("change");

      // Set Active Disclosure Item
      $disclosureOptions.removeClass("disclosure--option-active");

      $disclosureOptions.each(function (i, el) {
        if ($(el).find(".disclosure--option-link").data("value") === value) {
          $(el).addClass("disclosure--option-active");
        }
      });

      // Update Variant Price
      if ($variantPriceElement.length > 0) {
        $variantPriceElement.text(newOptionPrice);
      }
    };

    FrameworkDisclosure.prototype.setOptionOnClick = function () {
      var _this;
      _this = this;
      return _this.links.on("click keydown", function (event) {
        var option_selected_name, option_selected_value;

        if (event.key === "Enter") {
          _this.toggle.focus();
        } else if (event.type === "keydown") {
          return;
        }

        option_selected_value = $(this).attr("data-value");
        option_selected_name = $(this).text().replace("Sold Out", "");
        _this.toggleFormDisplay(false);
        _this.current_option.text(option_selected_name);
        _this.links.attr("aria-current", false);
        $(this).attr("aria-current", true);
        _this.input.val(option_selected_value);

        return _this.input.trigger("change");
      });
    };

    FrameworkDisclosure.prototype.toggleFormDisplay = function (open_form) {
      var _this;
      _this = this;
      return _this.toggle.attr("aria-expanded", open_form);
    };

    FrameworkDisclosure.prototype.configureFormDisplay = function () {
      var _this,
        clearance_height,
        close_to_bottom,
        close_to_top,
        distance_from_bottom,
        distance_from_top,
        height_of_canvas,
        height_of_toggle,
        max_form_height;
      _this = this;
      height_of_toggle = _this.toggle.outerHeight();
      clearance_height = height_of_toggle + _this.toggle_and_form_gap;
      height_of_canvas = _this.root.closest("[class^=off-canvas]").height();
      distance_from_top = _this.root.offset().top;
      distance_from_bottom =
        height_of_canvas - distance_from_top - height_of_toggle;
      close_to_bottom =
        _this.form_space_needed > distance_from_bottom &&
        distance_from_bottom < distance_from_top;
      close_to_top =
        _this.form_space_needed > distance_from_top &&
        distance_from_bottom > distance_from_top;
      max_form_height =
        $(window).height() - clearance_height - _this.window_and_form_gap;
      if (close_to_bottom) {
        max_form_height -= distance_from_bottom;
      } else if (close_to_top) {
        max_form_height -= distance_from_top;
      }
      _this.form.css("max-height", max_form_height + "px");
      if (close_to_bottom) {
        return _this.form.css(
          "top",
          "-" + (_this.form.height() + _this.toggle_and_form_gap) + "px"
        );
      } else {
        return _this.form.css("top", clearance_height + "px");
      }
    };

    FrameworkDisclosure.prototype.optionChangeCallback = function () {
      var _this;
      _this = this;
      return _this.input.on("change", function () {
        if (_this.type === "url-redirect") {
          return (window.location.href = $(this).val());
        } else if (_this.type === "localization") {
          return $(this).closest("form").submit();
        }
      });
    };

    return FrameworkDisclosure;
  })();

  theme.classes.FrameworkFeaturedBlog = (function () {
    function FrameworkFeaturedBlog(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find(".featured-blog--body");
      _this.items = _this.root.find(".featured-blog--item");
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedBlog.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".featured-blog--item--image"
      );
    };

    FrameworkFeaturedBlog.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.FeaturedGrid",
        theme.utils.debounce(100, function () {
          return _this.matchImageHeights();
        })
      );
    };

    return FrameworkFeaturedBlog;
  })();

  theme.classes.FrameworkFeaturedCollections = (function () {
    function FrameworkFeaturedCollections(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find(".featured-collections--body");
      _this.items = _this.root.find(".featured-collections--item");
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedCollections.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".featured-collections--image"
      );
    };

    FrameworkFeaturedCollections.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.FeaturedCollections",
        theme.utils.debounce(100, function () {
          return _this.matchImageHeights();
        })
      );
    };

    return FrameworkFeaturedCollections;
  })();

  theme.classes.FrameworkFeaturedContent = (function () {
    function FrameworkFeaturedContent(root) {
      var _this;
      this.root = root;
      _this = this;
    }

    return FrameworkFeaturedContent;
  })();

  theme.classes.FrameworkFeaturedGrid = (function () {
    function FrameworkFeaturedGrid(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.item_container = _this.root.find(".featured-grid--body");
      _this.items = _this.root.find(".featured-grid--item");
      _this.text_position = _this.root.data("text-position");
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    FrameworkFeaturedGrid.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      _this.items
        .find(".featured-grid--item--image, .placeholder--root")
        .css("height", "auto");
      if (
        _this.text_position === "center" &&
        theme.utils.mqs.current_window !== "small"
      ) {
        return;
      }
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".featured-grid--item--image"
      );
    };

    FrameworkFeaturedGrid.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.FeaturedGrid",
        theme.utils.debounce(100, function () {
          return _this.matchImageHeights();
        })
      );
    };

    return FrameworkFeaturedGrid;
  })();

  theme.classes.FrameworkFeaturedProduct = (function () {
    function FrameworkFeaturedProduct(root) {
      var _this;
      this.root = root;
      this.updateVariantImage = bind(this.updateVariantImage, this);
      this.thumbNavigation = bind(this.thumbNavigation, this);
      this.addProductComplete = bind(this.addProductComplete, this);
      this.addToCartListener = bind(this.addToCartListener, this);
      this.updateVariantImage = bind(this.updateVariantImage, this);
      this.variantSelected = bind(this.variantSelected, this);
      this.updateVariantOnOptionChange = bind(
        this.updateVariantOnOptionChange,
        this
      );
      this.load = bind(this.load, this);
      _this = this;
      _this.add_button = _this.root.find(".featured-product--add-to-cart");
      _this.cart_form = _this.root.find(".featured-product--cart-form > form");
      _this.compare_price = _this.root.find(".featured-product--compare-price");
      _this.main_images = _this.root.find(".featured-product--media");
      _this.onboarding = _this.root.data("onboarding");
      _this.option_inputs = _this.root.find(
        '[data-item="disclosure"], [data-item="radio"]'
      );
      _this.price = _this.root.find(".featured-product--actual-price");
      _this.price_wrapper = _this.root.find(".featured-product--price-wrapper");
      _this.smart_payment_buttons = _this.root.find(
        ".featured-product--smart-payment-buttons"
      );
      _this.thumbs = _this.root.find(".featured-product--thumb");
      _this.unavailable_variant = _this.root.find(
        ".featured-product--unavailable-variant"
      );
      _this.variants = JSON.parse(
        _this.root.find(".featured-product--json").text()
      ).variants;
      _this.variant_listbox = _this.root.find(
        ".featured-product--variant-select"
      );
      _this.variant_sold_out = _this.root.find(
        ".featured-product--sold-out--variant"
      );
      _this.load();
    }

    FrameworkFeaturedProduct.prototype.load = function () {
      var _this;
      _this = this;
      _this.addToCartListener();
      _this.thumbNavigation();

      if (_this.onboarding === false) {
        if (_this.variants.length > 1) {
          return _this.updateVariantOnOptionChange();
        }
      }
    };

    FrameworkFeaturedProduct.prototype.updateVariantOnOptionChange =
      function () {
        var _this;
        _this = this;
        return _this.option_inputs.on("change", function () {
          var current_options, i, len, options, ref, variant, variant_title;
          current_options = _this.root.find(
            '[data-item="disclosure"], [data-item="radio"]:checked'
          );
          options = [];
          current_options.each(function () {
            return options.push($(this).val().trim());
          });
          variant_title = options.join(" / ");
          ref = _this.variants;
          for (i = 0, len = ref.length; i < len; i++) {
            variant = ref[i];
            if (variant.title === variant_title) {
              return _this.variantSelected(variant);
            }
          }
          return _this.variantSelected(false);
        });
      };

    FrameworkFeaturedProduct.prototype.variantSelected = function (variant) {
      var _this, product_sold_out, variant_compare_price, variant_price;
      _this = this;
      product_sold_out = false;
      if (_this.root.find(".featured-product--sold-out--product").length) {
        product_sold_out = true;
      }
      _this.variant_sold_out.hide();
      _this.unavailable_variant.hide();
      _this.add_button.hide();
      _this.price_wrapper.hide();
      _this.variant_listbox.find("option[selected]").removeAttr("selected");
      if (!variant) {
        _this.unavailable_variant.show();
        _this.smart_payment_buttons.hide();
        return false;
      } else if (variant && variant.available) {
        _this.price_wrapper.show();
        _this.add_button.show();
        _this.smart_payment_buttons.show();
        _this.variant_listbox
          .find("option[value='" + variant.id + "']")
          .attr("selected", "");
      } else if (product_sold_out) {
        _this.variant_sold_out.hide();
        _this.add_button.hide();
        _this.smart_payment_buttons.hide();
      } else {
        _this.variant_sold_out.show();
        _this.smart_payment_buttons.hide();
      }
      variant_price = theme.utils.formatMoney(variant.price);
      _this.price.text(variant_price);
      if (variant.compare_at_price > variant.price) {
        variant_compare_price = theme.utils.formatMoney(
          variant.compare_at_price
        );
        _this.compare_price.text(variant_compare_price);
        _this.compare_price.show();
      } else {
        _this.compare_price.hide();
      }
      if (variant.featured_media) {
        return _this.updateVariantImage(variant.featured_media.id);
      }
    };

    FrameworkFeaturedProduct.prototype.updateVariantImage = function (
      variant_id
    ) {
      var _this, variant_image;
      _this = this;
      _this.main_images.attr("data-active", "false");
      variant_image = _this.main_images.filter(
        "[data-id='" + variant_id + "']"
      );
      return variant_image.attr("data-active", "true");
    };

    FrameworkFeaturedProduct.prototype.addToCartListener = function () {
      var _this;
      _this = this;
      if (_this.cart_form.length > 0 && theme.settings.cart_type === "drawer") {
        return _this.cart_form.on("submit", function () {
          _this.cart_form.find(".error").remove();
          _this.add_button.attr("data-loading", "true");
          theme.partials.Cart.addItem($(this), function (success, error) {
            if (success) {
              return theme.partials.Cart.updateAllHtml(function () {
                return _this.addProductComplete();
              });
            } else {
              _this.cart_form.append(
                "<div class='featured-product--error error'>" + error + "</div>"
              );
              return _this.add_button.attr("data-loading", "false");
            }
          });
          return false;
        });
      }
    };

    FrameworkFeaturedProduct.prototype.addProductComplete = function () {
      var _this;
      _this = this;
      _this.add_button.attr("data-loading", "false");
      return $('[data-off-canvas--open="right-sidebar"]')
        .first()
        .trigger("click");
    };

    FrameworkFeaturedProduct.prototype.thumbNavigation = function () {
      var _this;
      _this = this;
      return _this.thumbs.on("keypress click", function (event) {
        var clicked_id, clicked_media, current_media;
        if (theme.utils.a11yClick(event)) {
          current_media = _this.root.find(
            '.featured-product--media[data-active="true"] > *'
          );
          current_media.trigger("pause-media");
          clicked_id = $(this).attr("data-id");
          clicked_media = _this.root.find(
            ".featured-product--media[data-id='" +
            clicked_id +
            "'] > *:not(.a11y--focus-trigger)"
          );
          _this.updateVariantImage(clicked_id);
          if (theme.utils.mqs.current_window !== "small") {
            clicked_media.trigger("play-media");
          }
          if (clicked_media.parent().attr("data-media-type") !== "image") {
            return clicked_media.focus();
          }
        }
      });
    };

    FrameworkFeaturedProduct.prototype.updateVariantImage = function (
      variant_id
    ) {
      var _this, variant_image, variant_thumb;
      _this = this;
      _this.main_images.attr("data-active", "false");
      variant_image = _this.main_images.filter(
        "[data-id='" + variant_id + "']"
      );
      variant_image.attr("data-active", "true");
      _this.thumbs.attr("data-active", "false");
      variant_thumb = _this.thumbs.filter("[data-id='" + variant_id + "']");
      return variant_thumb.attr("data-active", "true");
    };

    return FrameworkFeaturedProduct;
  })();

  theme.classes.FrameworkFeaturedVideo = (function () {
    function FrameworkFeaturedVideo(root) {
      var _this;
      this.root = root;
      this.hideThumbnail = bind(this.hideThumbnail, this);
      this.playButtonListener = bind(this.playButtonListener, this);
      this.disablePlayerFocus = bind(this.disablePlayerFocus, this);
      this.vimeoEvents = bind(this.vimeoEvents, this);
      this.insertVimeoPlayer = bind(this.insertVimeoPlayer, this);
      this.youtubeEvents = bind(this.youtubeEvents, this);
      this.youtubeReady = bind(this.youtubeReady, this);
      this.insertYoutubePlayer = bind(this.insertYoutubePlayer, this);
      this.insertAPIScript = bind(this.insertAPIScript, this);
      this.playerInit = bind(this.playerInit, this);
      this.checkAPIScriptExists = bind(this.checkAPIScriptExists, this);
      _this = this;
      _this.play_buttons = _this.root.find(
        ".feature-video--play svg, .feature-video--play-mobile svg"
      );
      _this.section_id = _this.root.data("sectionId");
      _this.thumbnail = _this.root.data("thumbnail");
      _this.video_type = _this.root.data("videoType");
      _this.video_id = _this.root.data("videoId");
      _this.vimeoVars = {
        id: _this.video_id,
        autopause: 0,
        playsinline: 0,
        title: 0,
      };
      _this.youtubeVars = {};
      if (_this.thumbnail) {
        _this.playButtonListener();
      } else {
        _this.checkAPIScriptExists();
      }
    }

    FrameworkFeaturedVideo.prototype.checkAPIScriptExists = function () {
      var _this;
      _this = this;
      if (_this.video_type === "vimeo") {
        if (theme.utils.vimeoScriptAdded) {
          return _this.playerInit();
        } else {
          return _this.insertAPIScript(
            "https://player.vimeo.com/api/player.js"
          );
        }
      } else {
        if (theme.utils.youtubeScriptAdded) {
          return _this.playerInit();
        } else {
          return _this.insertAPIScript("https://www.youtube.com/iframe_api");
        }
      }
    };

    FrameworkFeaturedVideo.prototype.playerInit = function () {
      var _this;
      _this = this;
      if (_this.video_type === "vimeo") {
        if (_this.thumbnail) {
          return _this.insertVimeoPlayer();
        } else {
          $(window).on("load", function () {
            return _this.insertVimeoPlayer();
          });
          return _this.root.on("theme:section:load", function () {
            return _this.insertVimeoPlayer();
          });
        }
      } else {
        if (_this.thumbnail) {
          return _this.insertYoutubePlayer();
        } else {
          $(window).on("load", function () {
            return _this.insertYoutubePlayer();
          });
          return _this.root.on("theme:section:load", function () {
            return _this.insertYoutubePlayer();
          });
        }
      }
    };

    FrameworkFeaturedVideo.prototype.insertAPIScript = function (api_url) {
      var _this, script_tag;
      _this = this;
      script_tag = document.createElement("script");
      script_tag.src = api_url;
      if (_this.video_type === "vimeo") {
        theme.utils.vimeoScriptAdded = true;
        script_tag.onload = function () {
          return _this.insertVimeoPlayer();
        };
      } else {
        theme.utils.youtubeScriptAdded = true;
        $(window).on("theme.utils.youtubeAPIReady", function () {
          return _this.insertYoutubePlayer();
        });
      }
      return document.body.appendChild(script_tag);
    };

    FrameworkFeaturedVideo.prototype.insertYoutubePlayer = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.youtubeVars.enablejsapi = 1;
        _this.youtubeVars.origin = window.location.href;
        _this.youtubeVars.playsinline = 1;
        _this.youtubeVars.fs = 0;
        _this.youtubeVars.loop = 1;
        _this.youtubeVars.playlist = _this.video_id;
      }
      return (_this.player = new YT.Player("player-" + _this.section_id, {
        videoId: _this.video_id,
        playerVars: _this.youtubeVars,
        events: {
          onReady: _this.youtubeReady,
          onStateChange: _this.youtubeEvents,
        },
      }));
    };

    FrameworkFeaturedVideo.prototype.youtubeReady = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.player.mute();
        _this.disablePlayerFocus();
      }
      return _this.player.playVideo();
    };

    FrameworkFeaturedVideo.prototype.youtubeEvents = function (event) {
      var YTP, _this, remains;
      _this = this;
      YTP = event.target;
      if (_this.thumbnail) {
        if (event.data === 0) {
          YTP.seekTo(0);
          return YTP.pauseVideo();
        }
      } else {
        if (event.data === 1) {
          remains = YTP.getDuration() - YTP.getCurrentTime();
          if (_this.rewindTO) {
            clearTimeout(_this.rewindTO);
          }
          return (_this.rewindTO = setTimeout(function () {
            YTP.seekTo(0);
          }, (remains - 0.1) * 1000));
        }
      }
    };

    FrameworkFeaturedVideo.prototype.insertVimeoPlayer = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.vimeoVars.playsinline = 1;
        _this.vimeoVars.muted = 1;
        _this.vimeoVars.background = 1;
        _this.vimeoVars.loop = 1;
      }
      _this.player = new Vimeo.Player(
        "player-" + _this.section_id,
        _this.vimeoVars
      );
      if (_this.thumbnail) {
        _this.vimeoEvents();
      } else {
        _this.player.ready().then(function () {
          return _this.disablePlayerFocus();
        });
      }
      return _this.player.play();
    };

    FrameworkFeaturedVideo.prototype.vimeoEvents = function () {
      var _this;
      _this = this;
      _this.player.getDuration().then(function (duration) {
        return _this.player.addCuePoint(duration - 0.3, {});
      });
      return _this.player.on("cuepoint", function () {
        _this.player.setCurrentTime(0);
        return _this.player.pause();
      });
    };

    FrameworkFeaturedVideo.prototype.disablePlayerFocus = function () {
      var _this;
      _this = this;
      return _this.root.find("iframe").attr("tabindex", "-1");
    };

    FrameworkFeaturedVideo.prototype.playButtonListener = function () {
      var _this;
      _this = this;
      _this.play_buttons.attr("tabindex", "0");
      return _this.play_buttons.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        _this.checkAPIScriptExists();
        return _this.hideThumbnail();
      });
    };

    FrameworkFeaturedVideo.prototype.hideThumbnail = function () {
      var _this;
      _this = this;
      return setTimeout(function () {
        return _this.root
          .find(
            ".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile"
          )
          .hide();
      }, 350);
    };

    return FrameworkFeaturedVideo;
  })();

  theme.classes.FrameworkFeedbackBar = (function () {
    function FrameworkFeedbackBar(root) {
      var _this;
      this.root = root;
      this.load = bind(this.load, this);
      _this = this;
      _this.messages = _this.root.find(".feedback-bar--message span");
      _this.load();
    }

    FrameworkFeedbackBar.prototype.load = function () {
      var _this, anchor_tag, message, message_elem;
      _this = this;
      _this.messages.hide();
      anchor_tag = window.location.hash.substr(1);
      message = anchor_tag.replace("feedback-bar--", "");

      message_elem = _this.messages.filter(
        "[data-feedback-bar--message='" + message + "']"
      );
      if (message_elem.length) {
        message_elem.show();

        setTimeout(function () {
          return _this.root.attr("data-feedback-bar--open", "true");
        }, 300);

        return setTimeout(function () {
          return _this.root.attr("data-feedback-bar--open", "false");
        }, 6000);
      }
    };

    return FrameworkFeedbackBar;
  })();

  theme.classes.FrameworkFooter = (function () {
    function FrameworkFooter(root) {
      var _this;
      this.root = root;
      this.stickyFooter = bind(this.stickyFooter, this);
      this.addListeners = bind(this.addListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    FrameworkFooter.prototype.load = function () {
      var _this;
      _this = this;
      _this.addListeners();
      return _this.stickyFooter();
    };

    FrameworkFooter.prototype.addListeners = function () {
      var _this;
      _this = this;
      $(window).on("resize", function () {
        return _this.stickyFooter();
      });
      return $(document).on("shopify:section:load", function () {
        return _this.stickyFooter();
      });
    };

    FrameworkFooter.prototype.stickyFooter = function () {
      var _this, reduce_window_by, total_content_height;
      _this = this;
      $(".layout--main-content").css("min-height", "unset");
      total_content_height =
        $(".header--root").outerHeight() +
        $(".layout--main-content").outerHeight() +
        _this.root.outerHeight();
      if ($(".announcement--root").length > 0) {
        total_content_height += $(".announcement--root").outerHeight();
      }
      if ($(window).outerHeight() > total_content_height) {
        reduce_window_by =
          total_content_height - $(".layout--main-content").outerHeight();
        return $(".layout--main-content").css({
          "min-height": $(window).outerHeight() - reduce_window_by,
        });
      }
    };

    return FrameworkFooter;
  })();

  theme.classes.FrameworkMap = (function () {
    function FrameworkMap(root) {
      var _this;
      this.root = root;
      this.buildStyles = bind(this.buildStyles, this);
      this.buildMap = bind(this.buildMap, this);
      this.geolocate = bind(this.geolocate, this);
      this.loadMapsApi = bind(this.loadMapsApi, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.api_status = null;
      _this.map_instance = null;
      _this.key = _this.root.data("api-key");
      _this.address = _this.root.data("address");
      _this.theme = _this.root.data("theme");
      _this.styles = null;
      _this.container = _this.root.find(".map--google-maps");
      _this.center = null;
      _this.load();
    }

    FrameworkMap.prototype.load = function () {
      var _this;
      _this = this;
      if (_this.container.length > 0) {
        return _this.loadMapsApi();
      }
    };

    FrameworkMap.prototype.loadMapsApi = function () {
      var _this, other_map_loading_checker;
      _this = this;
      if (theme.utils.google_maps_script_status === "loading") {
        return (other_map_loading_checker = setInterval(function () {
          if (theme.utils.google_maps_script_status === "loaded") {
            _this.geolocate();
            return clearInterval(other_map_loading_checker);
          }
        }, 100));
      } else if (typeof window.google === "undefined") {
        theme.utils.google_maps_script_status = "loading";
        return $.getScript(
          "https://maps.googleapis.com/maps/api/js?key=" + _this.key
        ).then(function () {
          _this.geolocate();
          return (theme.utils.google_maps_script_status = "loaded");
        });
      } else {
        return _this.geolocate();
      }
    };

    FrameworkMap.prototype.geolocate = function () {
      var _this, geocoder;
      _this = this;
      geocoder = new google.maps.Geocoder();
      return geocoder.geocode(
        {
          address: _this.address,
        },
        function (results, status) {
          if (status === "OK") {
            _this.center = results[0].geometry.location;
            _this.buildStyles();
            return _this.buildMap();
          } else {
            return console.log("couldn't convert address with geocoder");
          }
        }
      );
    };

    FrameworkMap.prototype.buildMap = function () {
      var _this, center, map, mapOptions, marker;
      _this = this;
      mapOptions = {
        zoom: 15,
        center: _this.center,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        styles: _this.styles,
      };
      map = new google.maps.Map(_this.container[0], mapOptions);
      center = map.getCenter();
      marker = new google.maps.Marker({
        map: map,
        position: map.getCenter(),
      });
      return (_this.map_instance = google.maps.event.addDomListener(
        window,
        "resize",
        theme.utils.debounce(500, function () {
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        })
      ));
    };

    FrameworkMap.prototype.buildStyles = function () {
      var _this;
      _this = this;
      if (_this.theme === "grayscale") {
        return (_this.styles = [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ]);
      } else if (_this.theme === "dark") {
        return (_this.styles = [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d",
              },
            ],
          },
        ]);
      }
    };

    return FrameworkMap;
  })();

  theme.classes.FrameworkMediaQueries = (function () {
    function FrameworkMediaQueries() {
      this.screenSizeListener = bind(this.screenSizeListener, this);
      this.getScreenSize = bind(this.getScreenSize, this);
      this.medium_screen = 768;
      this.large_screen = 1024;
      this.current_window = null;
      this.getScreenSize();
      this.screenSizeListener();
    }

    FrameworkMediaQueries.prototype.getScreenSize = function () {
      var _this, previous_window;
      _this = this;
      previous_window = _this.current_window;
      if (
        window.matchMedia(
          "only screen and (min-width: " + _this.large_screen + "px)"
        ).matches
      ) {
        if (_this.current_window !== "large") {
          _this.current_window = "large";
        }
      } else if (
        window.matchMedia(
          "only screen and (min-width: " + _this.medium_screen + "px)"
        ).matches
      ) {
        if (_this.current_window !== "medium") {
          _this.current_window = "medium";
        }
      } else {
        if (_this.current_window !== "small") {
          _this.current_window = "small";
        }
      }
      if (_this.current_window !== previous_window) {
        return $(window).trigger("theme.utils.mqs.updated");
      }
    };

    FrameworkMediaQueries.prototype.screenSizeListener = function () {
      var _this;
      _this = this;
      return $(window).on("resize", function () {
        return _this.getScreenSize();
      });
    };

    return FrameworkMediaQueries;
  })();

  theme.classes.FrameworkModal = (function () {
    function FrameworkModal(root) {
      var _this;
      this.root = root;
      _this = this;
      _this.fullscreen = _this.root.data("modal-fullscreen") ? true : false;
      if (_this.root.data("modal-custom-close")) {
        _this.custom_close_button = _this.root.data("modal-custom-close");
      } else {
        _this.custom_close_button = "";
      }
      _this.force_view = _this.root.data("force-view");
      _this.view = _this.root.data("modal-view");
      _this.nested_links = _this.root.find(".modal--root .modal--link");
      _this.nested_content = _this.root.find(".modal--root .modal--content");
      _this.links = _this.root.find(".modal--link").not(_this.nested_links);
      _this.content = _this.root
        .find(".modal--content")
        .not(_this.nested_content);
      _this.window = $(".modal--window");
      _this.window_container = _this.window.find(".modal--container");
      _this.mask = _this.window.find(".modal--mask");
      _this.close_button = _this.window.find(".modal--close");
      _this.next_button = _this.window.find(".modal--next");
      _this.prev_button = _this.window.find(".modal--prev");
      _this.slider = null;
      _this.slides = null;
      // _this.main_content_window = $(".off-canvas--main-content");
      _this.openListeners();
      _this.modal_state = "closed";
      _this.nav_lock = false;
      _this.trigger_element = null;
    }

    FrameworkModal.prototype.openListeners = function () {
      var _this;
      _this = this;
      return _this.links.on(
        "keypress.FrameworkModal, click.FrameworkModal, quick-open",
        function (event) {
          var clicked_item, storedTrigger, triggerElement;
          if (
            event.type === "keypress" &&
            theme.utils.a11yClick(event) === false
          ) {
            return false;
          }
          clicked_item = $(this);
          storedTrigger = clicked_item.data("trigger-element");
          if (storedTrigger && storedTrigger.length) {
            triggerElement = storedTrigger;
            clicked_item.removeData("trigger-element");
          } else {
            triggerElement = $(document.activeElement);
            if (!triggerElement.length || triggerElement.is(clicked_item)) {
              triggerElement = clicked_item;
            }
          }
          _this.links.each(function (index) {
            if ($(this).is(clicked_item)) {
              _this.trigger_element = triggerElement;
              if (event.type === "quick-open") {
                return _this.open(index, true);
              } else {
                return _this.open(index);
              }
            }
          });
          return false;
        }
      );
    };

    FrameworkModal.prototype.open = function (index, quick_open) {
      var _this, scrolled_position;
      if (quick_open == null) {
        quick_open = false;
      }
      _this = this;
      if (_this.modal_state === "closed") {
        _this.modal_state = "opened";
        $("html").addClass("modal-open");
        _this.window.attr("data-modal-fullscreen", _this.fullscreen);
        _this.window.attr("data-modal-custom-close", _this.custom_close_button);
        _this.window.attr("data-modal-view", _this.view);
        _this.closeListeners();
        _this.positionListeners();
        scrolled_position = $(window).scrollTop();
        // _this.main_content_window.css({
        //   position: "fixed",
        //   top: -scrolled_position,
        // });
        _this.moveContentToWindow();
        if (_this.slides.length > 1) {
          _this.next_button.show();
          _this.prev_button.show();
          _this.prevListeners();
          _this.nextListeners();
        }
        _this.window.show();
        _this.window_container.show();
        _this.renderVideo(_this.slides.eq(index));
        _this.trapFocus();
        if (quick_open) {
          _this.slides.eq(index).addClass("active");
          return _this.position();
        } else {
          _this.mask.fadeIn();
          return _this.loadModal(_this.slides.eq(index), function () {
            return setTimeout(function () {
              return _this.window_container.find('input[type="text"]').focus();
            }, 0);
          });
        }
      }
    };

    FrameworkModal.prototype.moveContentToWindow = function (index) {
      var _this, content;
      _this = this;
      content = _this.root.find(".modal--content").not(_this.nested_content);
      _this.window_container.append(content);
      return (_this.slides = _this.window_container.find(".modal--content"));
    };

    FrameworkModal.prototype.renderVideo = function (slide) {
      var _this, id, iframe, src_url, type, video;
      _this = this;
      video = slide.find(".responsive-video").first();
      src_url = video.data("video");
      type = _this.extractVideoType(src_url);
      id = _this.extractVideoId(src_url, type);
      iframe = _this.createIframe(type, id);
      if (type === "vimeo") {
        video.addClass("vimeo");
      }
      if (type === "kickstarter") {
        video.addClass("kickstarter");
      }
      return video.append(iframe);
    };

    FrameworkModal.prototype.extractVideoType = function (src_url) {
      var _this, matches, re;
      _this = this;
      re =
        /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(src_url);
      if (matches) {
        return "youtube";
      }
      re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
      matches = re.exec(src_url);
      if (matches) {
        return "vimeo";
      }
      re = /^.*(kickstarter)\.com/g;
      matches = re.exec(src_url);
      if (matches) {
        return "kickstarter";
      }
      return false;
    };

    FrameworkModal.prototype.extractVideoId = function (src_url, type) {
      var _this, match, regExp;
      _this = this;
      if (type === "youtube") {
        regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = src_url.match(regExp);
        if (match) {
          return match[2];
        }
      } else if (type === "kickstarter") {
        regExp = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/;
        match = src_url.match(regExp);
        if (match) {
          return match[1];
        }
      }
    };

    FrameworkModal.prototype.createIframe = function (type, id) {
      var _this;
      _this = this;
      if (type === "youtube") {
        return (
          "<iframe src='//www.youtube.com/embed/" +
          id +
          "?autoplay=1' frameborder='0' allowfullwidth></iframe>"
        );
      } else if (type === "vimeo") {
        return (
          "<iframe src='//player.vimeo.com/video/" +
          id +
          "?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
        );
      } else if (type === "kickstarter") {
        return (
          "<iframe src='//www.kickstarter.com/projects/" +
          id +
          "/widget/video.html' frameborder='0' webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>"
        );
      }
    };

    FrameworkModal.prototype.removeVideos = function () {
      var _this;
      _this = this;
      return _this.slides.find(".responsive-video").each(function () {
        if ($(this).data("video")) {
          return $(this).find("iframe").remove();
        }
      });
    };

    FrameworkModal.prototype.loadModal = function (modal, callback) {
      var _this;
      _this = this;
      modal.addClass("active");
      _this.position();
      if (callback) {
        callback();
      }
      return (_this.nav_lock = false);
    };

    FrameworkModal.prototype.position = function () {
      var _this, active_modal, entire_modal_height, modal_height, modal_width;
      _this = this;
      if (_this.window_container != null) {
        active_modal = _this.content.filter(".active");
        _this.window_container.attr("style", "");
        _this.window.removeClass("fixed");
        modal_height = active_modal.outerHeight();
        modal_width = active_modal.outerWidth();
        entire_modal_height =
          modal_height +
          parseInt(_this.window.css("padding-top")) +
          parseInt(_this.window.css("padding-bottom"));
        if (_this.fullscreen) {
          return;
        }
        if (active_modal.hasClass("type--image")) {
          entire_modal_height = modal_height;
        }
        if (
          $(window).height() >= entire_modal_height &&
          _this.force_view !== "absolute"
        ) {
          return _this.window.addClass("fixed");
        } else {
          return _this.window.removeClass("fixed");
        }
      }
    };

    FrameworkModal.prototype.positionListeners = function () {
      var _this;
      _this = this;
      return $(window).on("resize.FrameworkModal", function () {
        return _this.position();
      });
    };

    FrameworkModal.prototype.nextListeners = function () {
      var _this;
      _this = this;
      $(document).on("keydown.FrameworkModal", function (event) {
        if (event.keyCode === 39) {
          return _this.next();
        }
      });
      return _this.next_button.on("click.FrameworkModal", function () {
        return _this.next();
      });
    };

    FrameworkModal.prototype.next = function () {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter(".active").index();
        _this.slides.removeClass("active");
        _this.removeVideos();
        if (index + 1 === _this.slides.length) {
          active_slide = _this.slides.eq(0);
        } else {
          active_slide = _this.slides.eq(index + 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.prevListeners = function () {
      var _this;
      _this = this;
      $(document).on("keydown.FrameworkModal", function (event) {
        if (event.keyCode === 37) {
          return _this.prev();
        }
      });
      return _this.prev_button.on("click.FrameworkModal", function () {
        return _this.prev();
      });
    };

    FrameworkModal.prototype.prev = function () {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter(".active").index();
        _this.slides.removeClass("active");
        _this.removeVideos();
        if (index === 0) {
          active_slide = _this.slides.eq(_this.slides.length - 1);
        } else {
          active_slide = _this.slides.eq(index - 1);
        }
        _this.renderVideo(active_slide);
        return _this.loadModal(active_slide);
      }
    };

    FrameworkModal.prototype.trapFocus = function () {
      var _this, activeElement, firstFocusable, focusableElements, lastFocusable;
      _this = this;
      $(document).on("keydown.FrameworkModalFocusTrap", function (event) {
        if (event.keyCode !== 9) {
          return;
        }
        focusableElements = _this.window.find(
          'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');
        if (focusableElements.length === 0) {
          return;
        }
        firstFocusable = focusableElements.first();
        lastFocusable = focusableElements.last();
        activeElement = document.activeElement;

        if (!_this.window[0].contains(activeElement)) {
          event.preventDefault();
          return firstFocusable.focus();
        }

        if (event.shiftKey) {
          if (activeElement === firstFocusable[0]) {
            event.preventDefault();
            return lastFocusable.focus();
          }
        } else {
          if (activeElement === lastFocusable[0]) {
            event.preventDefault();
            return firstFocusable.focus();
          }
        }
      });
    };

    FrameworkModal.prototype.closeListeners = function () {
      var _this;
      _this = this;
      _this.root.on("quick-close", function () {
        return _this.close(true);
      });
      $(document).on("keydown.FrameworkModal", function (event) {
        if (event.keyCode === 27) {
          return _this.close();
        }
      });
      _this.mask.on("click.FrameworkModal", function () {
        return _this.close();
      });
      _this.window_container.on("click.FrameworkModal", function () {
        return _this.close();
      });
      _this.content.on("click.FrameworkModal", function (event) {
        return event.stopPropagation();
      });
      return _this.close_button.on("click.FrameworkModal", function () {
        return _this.close();
      });
    };

    FrameworkModal.prototype.returnFocus = function () {
      var _this, bodyElement, elementToFocus, triggerElement;
      _this = this;
      triggerElement = _this.trigger_element;
      if (!triggerElement || !triggerElement.length) {
        bodyElement = $("body");
        if (!bodyElement.attr("tabindex")) {
          bodyElement.attr("tabindex", "-1");
        }
        return setTimeout(function () {
          bodyElement.focus();
          return bodyElement.removeAttr("tabindex");
        }, 0);
      }
      if (!document.body.contains(triggerElement[0])) {
        elementToFocus = triggerElement.closest("header").find("button[data-search-trigger]").first();
        if (!elementToFocus.length) {
          elementToFocus = $("button[data-search-trigger]").first();
        }
        if (!elementToFocus.length) {
          elementToFocus = $("a[href='" + theme.urls.search + "']").first();
        }
        if (!elementToFocus.length) {
          bodyElement = $("body");
          if (!bodyElement.attr("tabindex")) {
            bodyElement.attr("tabindex", "-1");
          }
          return setTimeout(function () {
            bodyElement.focus();
            return bodyElement.removeAttr("tabindex");
          }, 0);
        }
        return setTimeout(function () {
          return elementToFocus.focus();
        }, 0);
      }
      return setTimeout(function () {
        return triggerElement.focus();
      }, 0);
    };

    FrameworkModal.prototype.close = function (quick_close) {
      var _this, scrolled_position;
      if (quick_close == null) {
        quick_close = false;
      }
      _this = this;

      _this.root.trigger("modalClosed");

      $(window).scrollTop(scrolled_position);
      _this.putBackContent();
      _this.next_button.hide();
      _this.prev_button.hide();
      _this.window.hide();
      if (quick_close) {
        _this.mask.hide();
        this.window_container.empty();
        _this.modal_state = "closed";
        _this.returnFocus();
      } else {
        _this.mask.fadeOut(function () {
          _this.window_container.empty();
          _this.modal_state = "closed";
          return _this.returnFocus();
        });
      }
      $("html").removeClass("modal-open");
      _this.removeListeners();
      return $(window).trigger("FrameworkModal.afterClose");
    };

    FrameworkModal.prototype.putBackContent = function () {
      var _this;
      _this = this;
      _this.removeVideos();
      return _this.slides.removeClass("active").appendTo(_this.root);
    };

    FrameworkModal.prototype.removeListeners = function () {
      var _this;
      _this = this;
      $(document).off("keydown.FrameworkModal");
      $(document).off("keydown.FrameworkModalFocusTrap");
      $(window).off("resize.FrameworkModal");

      _this.next_button.off("click.FrameworkModal");
      _this.prev_button.off("click.FrameworkModal");
      _this.close_button.off("click.FrameworkModal");
      _this.mask.off("click.FrameworkModal");
      return _this.window_container.off("click.FrameworkModal");
    };

    return FrameworkModal;
  })();

  theme.classes.FrameworkOffCanvas = (function () {
    function FrameworkOffCanvas(root) {
      var _this;
      this.root = root;
      this.touchListener = bind(this.touchListener, this);
      this.closeRight = bind(this.closeRight, this);
      this.closeLeft = bind(this.closeLeft, this);
      this.fadeInOverlay = bind(this.fadeInOverlay, this);
      this.openRight = bind(this.openRight, this);
      this.openLeft = bind(this.openLeft, this);
      this.toggle = bind(this.toggle, this);
      this.closeWithEscKey = bind(this.closeWithEscKey, this);
      this.closeWhenFocusOut = bind(this.closeWhenFocusOut, this);
      this.disableFocusItems = bind(this.disableFocusItems, this);
      this.toggleListeners = bind(this.toggleListeners, this);
      this.viewPortHeightListener = bind(this.viewPortHeightListener, this);
      this.setViewPortHeight = bind(this.setViewPortHeight, this);
      this.setState = bind(this.setState, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.viewport = $(".off-canvas--viewport");
      _this.left_sidebar = $(".off-canvas--left-sidebar");
      _this.right_sidebar = $(".off-canvas--right-sidebar");
      _this.focus_triggers = $(".off-canvas--focus-trigger");
      // _this.main_content = $(".off-canvas--main-content");
      _this.overlay = $(".off-canvas--overlay");
      _this.state = "closed";
      _this.load();
    }

    FrameworkOffCanvas.prototype.load = function () {
      var _this;
      _this = this;
      _this.close = $(".off-canvas--close");
      _this.triggers = $(".off-canvas--open");
      _this.setViewPortHeight();
      _this.viewPortHeightListener();
      _this.toggleListeners();
      _this.touchListener();
      _this.disableFocusItems();
      _this.closeWhenFocusOut();
      return _this.closeWithEscKey();
    };

    FrameworkOffCanvas.prototype.unload = function () {
      var _this;
      _this = this;
      _this.triggers.off("click keydown");
      _this.overlay.add(_this.close).off("click");
      $(document).off("touchstart.OffCanvas");
      return $(document).off("touchend.OffCanvas");
    };

    FrameworkOffCanvas.prototype.setState = function (state) {
      var _this;
      _this = this;
      _this.state = state;
      return _this.root.attr("data-off-canvas--state", state);
    };

    FrameworkOffCanvas.prototype.setViewPortHeight = function () {
      var _this;
      _this = this;
      return _this.viewport.css({
        "min-height": $(window).height(),
      });
    };

    FrameworkOffCanvas.prototype.viewPortHeightListener = function () {
      var _this;
      _this = this;
      return $(window).on("resize", function () {
        return _this.setViewPortHeight();
      });
    };

    FrameworkOffCanvas.prototype.toggleListeners = function () {

      var _this;
      _this = this;
      _this.triggers.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        if ($(this).data("off-canvas--open") === "left-sidebar") {
          _this.toggle("left-sidebar");
        } else if ($(this).data("off-canvas--open") === "right-sidebar") {
          _this.right_sidebar_view = $(this).data("off-canvas--view");
          _this.right_sidebar.attr("data-active", _this.right_sidebar_view);
          _this.toggle("right-sidebar");
        }
        return false;
      });
      return _this.overlay.add(_this.close).on("click", function () {
        if (_this.state === "left-open") {
          return _this.toggle("left-sidebar");
        } else if (_this.state === "right-open") {
          return _this.toggle("right-sidebar");
        }
      });
    };

    FrameworkOffCanvas.prototype.disableFocusItems = function () {
      var _this;
      _this = this;
      return $(window).on("load", function () {
        _this.left_sidebar.find(":focusable").attr("tabindex", "-1");
        _this.right_sidebar.find(":focusable").attr("tabindex", "-1");
        return _this.right_sidebar
          .find(".cart--additional-buttons")
          .css("visibility", "hidden");
      });
    };

    FrameworkOffCanvas.prototype.closeWhenFocusOut = function () {
      var _this;
      _this = this;
      return _this.focus_triggers.on("focus", function () {
        if (_this.state === "left-open") {
          return _this.closeLeft();
        } else if (_this.state === "right-open") {
          return _this.closeRight();
        }
      });
    };

    FrameworkOffCanvas.prototype.closeWithEscKey = function () {
      var _this;
      _this = this;
      return $(window).on("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        if (_this.state === "left-open") {
          return _this.closeLeft();
        } else if (_this.state === "right-open") {
          return _this.closeRight();
        }
      });
    };

    FrameworkOffCanvas.prototype.toggle = function (element) {
      var _this;
      _this = this;
      if (element === "left-sidebar" && _this.state === "closed") {
        return _this.openLeft();
      } else if (element === "left-sidebar" && _this.state === "left-open") {
        return _this.closeLeft();
      } else if (element === "right-sidebar" && _this.state === "closed") {
        return _this.openRight();
      } else if (element === "right-sidebar" && _this.state === "right-open") {
        return _this.closeRight();
      }
    };

    FrameworkOffCanvas.prototype.openLeft = function () {
      var _this;
      _this = this;
      _this.setState("left-open");
      _this.left_sidebar
        .find('[tabindex="-1"]')
        .not('[data-item="hidden-text"] a')
        .attr("tabindex", "0");
      // _this.main_content.css({
      //   position: "fixed",
      //   top: -$(window).scrollTop(),
      // });

      _this.left_sidebar.css({
        display: "block",
      });

      _this.left_sidebar.velocity(
        {
          translateX: [0, "-100%"],
        },
        {
          complete: function () {
            _this.left_sidebar.css("position", "relative");
            return _this.left_sidebar
              .find(":focusable:eq(1):not('.off-canvas--focus-trigger')")
              .focus();
          },
        }
      );
      return _this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.openRight = function () {
      var _this;
      _this = this;
      _this.setState("right-open");
      _this.right_sidebar
        .find('[tabindex="-1"]:not(input)')
        .attr("tabindex", "0");
      _this.right_sidebar
        .find(".cart--additional-buttons")
        .css("visibility", "unset");

      _this.right_sidebar.css({
        display: "block",
      });

      // _this.main_content.css({
      //   position: "fixed",
      //   top: -$(window).scrollTop(),
      // });
      _this.right_sidebar.velocity(
        {
          translateX: ["-100%", 0],
        },
        {
          complete: function () {
            _this.right_sidebar.css("position", "relative");
            return _this.right_sidebar
              .find(":focusable:eq(1):not('.off-canvas--focus-trigger')")
              .focus();
          },
        }
      );
      return _this.fadeInOverlay();
    };

    FrameworkOffCanvas.prototype.fadeInOverlay = function () {
      var _this;
      _this = this;
      _this.overlay.show();
      return _this.overlay.velocity({
        opacity: "0.3",
      });
    };

    FrameworkOffCanvas.prototype.closeLeft = function () {
      var _this, scrolled_position;
      _this = this;
      if (_this.state !== "left-open") {
        return false;
      }
      _this.setState("closed");
      _this.left_sidebar.find('[tabindex="0"]').attr("tabindex", "-1");
      // scrolled_position = parseInt(_this.main_content.css("top")) * -1;

      _this.left_sidebar.css({
        display: "block",
      });

      _this.left_sidebar.velocity(
        {
          translateX: ["-100%", 0],
        },
        {
          complete: function () {
            _this.left_sidebar.css({
              position: "absolute",
              display: "none",
            });
            // _this.main_content.css({
            //   position: "relative",
            //   top: "initial",
            // });
            return $(window).scrollTop(scrolled_position);
          },
        }
      );
      _this.overlay.velocity("fadeOut");
      return $("[data-off-canvas--open='left-sidebar']").focus();
    };

    FrameworkOffCanvas.prototype.closeRight = function () {
      var _this, scrolled_position;
      _this = this;
      if (_this.state !== "right-open") {
        return false;
      }
      _this.setState("closed");
      _this.right_sidebar.find(":focusable").attr("tabindex", "-1");
      _this.right_sidebar
        .find(".cart--additional-buttons")
        .css("visibility", "hidden");

      // scrolled_position = parseInt(_this.main_content.css("top")) * -1;

      _this.right_sidebar.css({
        display: "block",
      });

      _this.right_sidebar.velocity(
        {
          translateX: [0, "-100%"],
        },
        {
          complete: function () {
            _this.right_sidebar.css({
              position: "absolute",
              display: "none",
            });
            // _this.main_content.css({
            //   position: "relative",
            //   top: "initial",
            // });
            return $(window).scrollTop(scrolled_position);
          },
        }
      );
      return _this.overlay.velocity("fadeOut");
    };

    FrameworkOffCanvas.prototype.touchListener = function () {
      var _this, position;
      _this = this;
      if (!theme.utils.isTouchDevice()) {
        return false;
      }
      position = {
        start: {},
        end: {},
      };
      $(document).on("touchstart.OffCanvas", function (event) {
        position.start.x = event.originalEvent.touches[0].clientX;
        position.start.y = event.originalEvent.touches[0].clientY;
      });
      return $(document).on("touchend.OffCanvas", function (event) {
        position.end.x = event.originalEvent.changedTouches[0].clientX;
        position.end.y = event.originalEvent.changedTouches[0].clientY;
        if (Math.abs(position.start.y - position.end.y) > 30) {
          return false;
        }
        if (position.start.x > position.end.x + 5) {
          return _this.closeLeft();
        } else if (position.start.x < position.end.x - 5) {
          return _this.closeRight();
        }
      });
    };

    return FrameworkOffCanvas;
  })();

  theme.classes.FrameworkPasswordPage = (function () {
    function FrameworkPasswordPage(root) {
      var _this;
      this.root = root;
      this.disableSidebars = bind(this.disableSidebars, this);
      this.cancelLoginListener = bind(this.cancelLoginListener, this);
      this.loginFormListener = bind(this.loginFormListener, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.login_form = _this.root.find(".password--login-form");
      _this.login_cancel = _this.root.find(".password--cancel");
      _this.login_link = _this.root.find(".password--login-link");
      _this.signup_form = _this.root.find(".password--main > *");
      _this.load();
    }

    FrameworkPasswordPage.prototype.load = function () {
      var _this;
      _this = this;
      _this.loginFormListener();
      _this.cancelLoginListener();
      return _this.disableSidebars();
    };

    FrameworkPasswordPage.prototype.loginFormListener = function () {
      var _this;
      _this = this;
      return _this.login_link.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        $(this).css("visibility", "hidden");
        _this.signup_form.hide();
        _this.login_form.css("visibility", "visible");
        return _this.login_form.find('input[type="password"]').focus();
      });
    };

    FrameworkPasswordPage.prototype.cancelLoginListener = function () {
      var _this;
      _this = this;
      return _this.login_cancel.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        _this.signup_form.fadeIn();
        _this.login_form.css("visibility", "hidden");
        return _this.login_link.css("visibility", "visible");
      });
    };

    FrameworkPasswordPage.prototype.disableSidebars = function () {
      var _this;
      _this = this;
      return $(".off-canvas--left-sidebar, .off-canvas--right-sidebar").hide();
    };

    return FrameworkPasswordPage;
  })();

  theme.classes.FrameworkProductModel = (function () {
    function FrameworkProductModel(root) {
      var _this;
      this.root = root;
      this.loadModel = bind(this.loadModel, this);
      this.loadAssets = bind(this.loadAssets, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.view = _this.root.data("view");
      _this.key = _this.root.closest("[data-id]").data("id");
      _this.cdn =
        "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui";
      _this.load();
    }

    FrameworkProductModel.prototype.load = function () {
      var _this;
      _this = this;
      _this.eventListeners();
      if (theme.utils.modelScriptAdded) {
        return;
      }
      theme.utils.modelScriptAdded = true;
      return _this.loadAssets();
    };

    FrameworkProductModel.prototype.eventListeners = function () {
      var _this;
      _this = this;
      _this.root.on("model-ready", function () {
        return _this.loadModel();
      });
      _this.root.on("theme:section:load", function () {
        return _this.loadModel();
      });
      _this.root.on("pause-media", function () {
        if (_this.model) {
          return _this.model.pause();
        }
      });
      _this.root.on("play-media", function () {
        if (_this.model) {
          return _this.model.play();
        }
      });
      return $(window).on(
        "resize.ProductModel",
        theme.utils.debounce(250, function () {
          $(".product-model--root").trigger("pause-media");
          return $(".product-model--root").trigger("model-ready");
        })
      );
    };

    FrameworkProductModel.prototype.loadAssets = function () {
      var _this;
      _this = this;
      theme.utils.insertStylesheet(_this.cdn + ".css");
      return theme.utils.insertScript(_this.cdn + ".en.js", function () {
        return $(".product-model--root").trigger("model-ready");
      });
    };

    FrameworkProductModel.prototype.loadModel = function () {
      var _this;
      _this = this;
      if (_this.model) {
        return;
      }
      if (
        theme.utils.mqs.current_window === "small" &&
        _this.view === "desktop"
      ) {
        return;
      } else if (
        theme.utils.mqs.current_window !== "small" &&
        _this.view === "mobile"
      ) {
        return;
      }
      return (_this.model = new Shopify.ModelViewerUI(
        _this.root.find("model-viewer")
      ));
    };

    return FrameworkProductModel;
  })();

  theme.classes.FrameworkProductRecommendations = (function () {
    function FrameworkProductRecommendations(root) {
      var _this;
      this.root = root;
      this.loadHoverImages = bind(this.loadHoverImages, this);
      this.checkIfEmpty = bind(this.checkIfEmpty, this);
      this.loadProducts = bind(this.loadProducts, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.loadProducts();
      _this.resizeListeners();
    }

    FrameworkProductRecommendations.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      _this.item_container = _this.root.find(".product-recommendations--body");
      _this.items = _this.root.find(".product--root");
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".product--image-wrapper"
      );
    };

    FrameworkProductRecommendations.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize",
        theme.utils.debounce(100, function () {
          return _this.matchImageHeights();
        })
      );
    };

    FrameworkProductRecommendations.prototype.loadProducts = function () {
      var _this,
        max_products,
        product_id,
        product_recommendations,
        request,
        request_url;
      _this = this;
      product_recommendations = document.getElementsByClassName(
        "product-recommendations--root"
      )[0];
      product_id = product_recommendations.dataset.productId;
      max_products = product_recommendations.dataset.maxProducts;
      request_url =
        theme.urls.product_recommendations +
        "?section_id=framework--product-recommendations&limit=" +
        max_products +
        "&product_id=" +
        product_id;
      request = new XMLHttpRequest();
      request.onload = function () {
        var container;
        if (request.status >= 200 && request.status < 300) {
          container = document.createElement("div");
          container.innerHTML = request.response;
          product_recommendations.innerHTML = container.querySelector(
            ".product-recommendations--root"
          ).innerHTML;
          _this.matchImageHeights();
          _this.checkIfEmpty();
          return _this.loadHoverImages();
        }
      };
      request.open("GET", request_url);
      return request.send();
    };

    FrameworkProductRecommendations.prototype.checkIfEmpty = function () {
      var _this, empty;
      _this = this;
      empty = $(".product--root").length > 0 ? false : true;
      return $(".product-recommendations--root").attr("data-empty", empty);
    };

    FrameworkProductRecommendations.prototype.loadHoverImages = function () {
      var _this;
      _this = this;
      return $('.product--root[data-hover-image="true"]').each(function () {
        var product;
        product = $(this);
        return theme.utils.imagesLoaded(product, function () {
          return product.attr("data-hover-image", "loaded");
        });
      });
    };

    return FrameworkProductRecommendations;
  })();

  theme.classes.FrameworkProductVideo = (function () {
    function FrameworkProductVideo(root) {
      var _this;
      this.root = root;
      this.skipVideo = bind(this.skipVideo, this);
      this.loadYoutubeVideo = bind(this.loadYoutubeVideo, this);
      this.loadPlyrVideo = bind(this.loadPlyrVideo, this);
      this.loadYoutubeAsset = bind(this.loadYoutubeAsset, this);
      this.loadPlyrAssets = bind(this.loadPlyrAssets, this);
      this.resizeListener = bind(this.resizeListener, this);
      this.youtubeListeners = bind(this.youtubeListeners, this);
      this.plyrListeners = bind(this.plyrListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.view = _this.root.data("view");
      _this.type = _this.root.data("type");
      _this.loop_enabled = _this.root.data("loop-enabled");
      _this.load();
    }

    FrameworkProductVideo.prototype.load = function () {
      var _this;
      _this = this;
      _this.resizeListener();
      if (_this.type === "youtube") {
        _this.id = _this.root.find(".product-video").attr("id");
        _this.video_id = _this.root.data("video-id");
        _this.youtubeListeners();
        return _this.loadYoutubeAsset();
      } else {
        _this.plyr_cdn =
          "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr";
        _this.plyrListeners();
        return _this.loadPlyrAssets();
      }
    };

    FrameworkProductVideo.prototype.plyrListeners = function () {
      var _this;
      _this = this;
      _this.root.on("plyr-video-ready", function () {
        return _this.loadPlyrVideo();
      });
      _this.root.on("theme:section:load", function () {
        return _this.loadPlyrVideo();
      });
      _this.root.on("pause-media", function () {
        if (_this.video) {
          return _this.video.pause();
        }
      });
      return _this.root.on("play-media", function () {
        if (_this.video) {
          return _this.video.play();
        }
      });
    };

    FrameworkProductVideo.prototype.youtubeListeners = function () {
      var _this;
      _this = this;
      $(window).on("theme.utils.youtubeAPIReady", function () {
        return _this.loadYoutubeVideo();
      });
      return _this.root.on("theme:section:load", function () {
        return _this.loadYoutubeVideo();
      });
    };

    FrameworkProductVideo.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.ProductVideo",
        theme.utils.debounce(250, function () {
          $(".product-video--root").trigger("pause-media");
          $(".product-video--root").trigger("plyr-video-ready");
          return $(".product-video--root").trigger(
            "theme.utils.youtubeAPIReady"
          );
        })
      );
    };

    FrameworkProductVideo.prototype.loadPlyrAssets = function () {
      var _this;
      _this = this;
      if (theme.utils.plyrScriptAdded) {
        return;
      }
      theme.utils.plyrScriptAdded = true;
      theme.utils.insertStylesheet(_this.plyr_cdn + ".css");
      return theme.utils.insertScript(_this.plyr_cdn + ".en.js", function () {
        return $(".product-video--root").trigger("plyr-video-ready");
      });
    };

    FrameworkProductVideo.prototype.loadYoutubeAsset = function () {
      var _this;
      _this = this;
      if (theme.utils.youtubeScriptAdded) {
        return;
      }
      theme.utils.youtubeScriptAdded = true;
      return theme.utils.insertScript("https://www.youtube.com/iframe_api");
    };

    FrameworkProductVideo.prototype.loadPlyrVideo = function () {
      var _this;
      _this = this;
      if (_this.video) {
        return;
      }
      if (_this.skipVideo()) {
        return;
      }
      return (_this.video = new Shopify.Plyr(_this.root.find("video"), {
        iconUrl: _this.plyr_cdn + ".svg",
        loop: {
          active: _this.loop_enabled,
        },
      }));
    };

    FrameworkProductVideo.prototype.loadYoutubeVideo = function () {
      var _this;
      _this = this;
      if (_this.video) {
        return;
      }
      if (_this.skipVideo()) {
        return;
      }
      return (_this.video = new YT.Player(_this.id, {
        videoId: _this.video_id,
        events: {
          onReady: function (event) {
            _this.root.on("pause-media", function () {
              return event.target.pauseVideo();
            });
            return _this.root.on("play-media", function () {
              return event.target.playVideo();
            });
          },
          onStateChange: function (event) {
            if (event.data === 0 && _this.loop_enabled) {
              event.target.seekTo(0);
            }
            if (event.data === 1) {
              return $(".product-media--featured > *")
                .not(_this.root)
                .trigger("pause-media");
            }
          },
        },
      }));
    };

    FrameworkProductVideo.prototype.skipVideo = function () {
      var _this;
      _this = this;
      if (
        theme.utils.mqs.current_window === "small" &&
        _this.view === "desktop"
      ) {
        return true;
      } else if (
        theme.utils.mqs.current_window !== "small" &&
        _this.view === "mobile"
      ) {
        return true;
      } else {
        return false;
      }
    };

    return FrameworkProductVideo;
  })();

  theme.classes.FrameworkProduct = (function () {
    function FrameworkProduct(root) {
      var _this;
      this.root = root;
      this.modalCloseListener = bind(this.modalCloseListener, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.getActiveImageId = bind(this.getActiveImageId, this);
      this.imageZoom = bind(this.imageZoom, this);
      this.updateVariantMedia = bind(this.updateVariantMedia, this);
      this.thumbNavigation = bind(this.thumbNavigation, this);
      this.addProductComplete = bind(this.addProductComplete, this);
      this.addToCartListener = bind(this.addToCartListener, this);
      this.updatePrices = bind(this.updatePrices, this);
      this.enableStockForm = bind(this.enableStockForm, this);
      this.enableCartButtons = bind(this.enableCartButtons, this);
      this.variantSelected = bind(this.variantSelected, this);
      this.updateHistoryState = bind(this.updateHistoryState, this);
      this.optionChangeListener = bind(this.optionChangeListener, this);
      this.updateLowInStock = bind(this.updateLowInStock, this);
      this.sizeChart = bind(this.sizeChart, this);
      this.getProductJson = bind(this.getProductJson, this);
      this.updatePickup = bind(this.updatePickup, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.form_root = _this.root.find(".product-form--root");
      _this.handle = _this.form_root.attr("data-handle");
      _this.thumbs_root = _this.root.find(
        '.product-media--root[data-view="thumbs"]'
      );
      _this.featured_root = _this.root
        .find('.product-media--root[data-view="featured"]')
        .not('[data-media-size="mobile"]');
      _this.magnify = _this.featured_root.data("magnify");
      _this.main_media = _this.featured_root.find(".product-media--featured");
      _this.media_container = _this.featured_root.closest(
        ".product-media--wrapper"
      );
      _this.thumbs = _this.thumbs_root.find(".product-media--thumb");
      _this.zoom_enabled = _this.featured_root.data("zoom-enabled");
      _this.zoom_images = _this.featured_root.find(
        ".product-media--zoom-image"
      );
      _this.add_to_cart_button = _this.form_root.find(
        ".product-form--add-to-cart"
      );
      _this.pickup_enabled = _this.form_root.data("pickup-enabled");
      _this.button_container = _this.form_root.find(
        ".product-form--button-container"
      );
      _this.button_text_container = _this.form_root.find(".product-form--text");
      _this.callback_enabled = _this.form_root.data("callback-enabled");
      _this.compare_price = _this.form_root.find(
        ".product-form--compare-price"
      );
      _this.form = _this.form_root.find(".product-form--container");
      _this.low_stock_container = _this.form_root.find(
        ".product-form--low-stock"
      );
      _this.low_stock_threshold = _this.form_root.data("low-stock-amount");
      _this.pickup_drawer_container = $(
        '.off-canvas--container[data-view="pickup"]'
      );
      _this.pickup_form_container = _this.root.find(".product-form--pickup");
      _this.price = _this.form_root.find(".product-form--price");
      _this.product_title = _this.form_root.data("title");
      _this.show_low_in_stock =
        _this.low_stock_threshold === void 0 ? false : true;
      _this.reference_unit = _this.form_root.find(
        ".product-form--reference-unit"
      );
      _this.reference_value = _this.form_root.find(
        ".product-form--reference-value"
      );
      _this.size_chart_enabled = _this.form_root.data("size-chart-enabled");
      _this.size_chart_option = _this.form_root.attr("data-size-chart-option");
      _this.smart_payment_buttons = _this.form_root.find(
        ".product-form--smart-payment-buttons"
      );
      _this.sold_out = _this.form_root.data("sold-out");
      _this.unavailable_container = _this.form_root.find(
        ".product-form--unavailable"
      );
      _this.unavailable_button =
        _this.unavailable_container.find('[type="submit"]');
      _this.unit_price_container = _this.form_root.find(
        ".product-form--unit-price-container"
      );
      _this.unit_price = _this.form_root.find(".product-form--unit-price");
      _this.variant_container = _this.form_root.find(".product-form--variants");
      _this.variant_listbox = _this.form_root.find(
        ".product-form--variant-select"
      );
      _this.first_variant_id = parseInt(
        _this.variant_listbox.find("[selected]").val()
      );
      _this.option_inputs = _this.variant_container.find(
        '[data-item="disclosure"], [data-item="radio"]'
      );
      _this.load();
    }

    FrameworkProduct.prototype.load = function () {
      var _this;
      _this = this;

      if (_this.handle) {
        _this.getProductJson();
      }

      if (_this.pickup_enabled) {
        _this.updatePickup(_this.first_variant_id);
      }

      if (_this.show_low_in_stock) {
        _this.updateLowInStock(_this.first_variant_id);
      }
      if (theme.settings.cart_type === "drawer") {
        _this.addToCartListener();
      }

      if (_this.zoom_enabled) {
        _this.imageZoom();
        _this.resizeListeners();
        _this.modalCloseListener();
      }
      if (_this.thumbs) {
        return _this.thumbNavigation();
      }
    };

    FrameworkProduct.prototype.updatePickup = function (variant_id) {
      var _this, request;
      _this = this;
      request = new XMLHttpRequest();
      request.onload = function () {
        var drawer_html, form_html, root_html;
        if (request.status >= 200 && request.status < 300) {
          root_html = $($.parseHTML(request.response));
          form_html = root_html.find(".pickup--form--container");
          _this.pickup_form_container.html(form_html);
          drawer_html = root_html.find(".pickup--drawer--container");
          drawer_html
            .find(".pickup--drawer--product-title")
            .text(_this.product_title);
          _this.pickup_drawer_container.html(drawer_html);
          theme.partials?.OffCanvas?.unload();
          theme.partials?.OffCanvas?.load();
          return;
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": product pickup request failed!"
        );
      };
      request.open(
        "GET",
        "/variants/" + variant_id + "/?section_id=framework--pickup"
      );
      return request.send();
    };

    FrameworkProduct.prototype.getProductJson = function () {
      var _this, request;
      _this = this;
      request = new XMLHttpRequest();
      request.onload = function () {
        var product_json;
        product_json = JSON.parse(request.response);
        if (product_json.variants.length > 1) {
          _this.optionChangeListener(product_json.variants);
          _this.variant_listbox.trigger("change");

          if (_this.size_chart_enabled) {
            return _this.sizeChart(product_json.options);
          }
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": product.json request failed!"
        );
      };
      request.open("GET", "/products/" + _this.handle + ".js");
      return request.send();
    };

    FrameworkProduct.prototype.sizeChart = function (variant_options) {
      var _this;
      _this = this;
      _this.form_root
        .find(".disclosure--root, .radios--header")
        .each(function (index) {
          if (
            variant_options[index].name.toLowerCase() ===
            _this.size_chart_option.toLowerCase()
          ) {
            $(this).append(
              "<div class='product-form--modal-link' data-item='block-link'> <a class='modal--link' href='#'> " +
              theme.translations.size_chart_label +
              " </a> </div>"
            );
            return false;
          }
        });
      return new theme.classes.FrameworkModal(
        _this.form_root.find('[data-js-class="FrameworkModal"]')
      );
    };

    FrameworkProduct.prototype.updateLowInStock = function (variant_id) {
      var _this, message, quantity;
      _this = this;
      quantity = _this.variant_listbox
        .find("[value='" + variant_id + "']")
        .data("inventory-quantity");
      if (quantity === void 0) {
        return;
      } else if (quantity === 1) {
        message = theme.translations.low_in_stock.one;
      } else if (quantity > 1) {
        message = theme.translations.low_in_stock.other;
        message = message.replace(/\d+/, quantity);
      }
      return _this.low_stock_container.text(message).show();
    };

    FrameworkProduct.prototype.optionChangeListener = function (variants) {
      var _this, updateVariant;
      _this = this;
      updateVariant = function (variant) {
        if (_this.callback_enabled) {
          _this.updateHistoryState(variant.id);
          return selectCallback(variant);
        } else {
          return _this.variantSelected(variant);
        }
      };
      return _this.option_inputs.on("change", function () {
        var current_options, i, len, options, variant, variant_title;
        current_options = _this.variant_container.find(
          '[data-item="disclosure"], [data-item="radio"]:checked'
        );
        options = [];
        current_options.each(function () {
          return options.push($(this).val().trim());
        });
        variant_title = options.join(" / ");
        for (i = 0, len = variants.length; i < len; i++) {
          variant = variants[i];
          if (variant.title === variant_title) {
            updateVariant(variant);
            return;
          }
        }
        return updateVariant(false);
      });
    };

    FrameworkProduct.prototype.updateHistoryState = function (variant_id) {
      var _this, new_variant_url;
      _this = this;
      new_variant_url =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      if (variant_id) {
        new_variant_url += "?variant=" + variant_id;
      }
      return window.history.replaceState(
        {
          path: new_variant_url,
        },
        "",
        new_variant_url
      );
    };

    FrameworkProduct.prototype.variantSelected = function (variant) {
      var _this;
      _this = this;

      _this.form.find(".product-form--error").remove();
      _this.low_stock_container.hide();
      _this.variant_listbox.find("option[selected]").removeAttr("selected");

      if (variant && variant.available) {
        if (_this.pickup_enabled) {
          _this.updatePickup(variant.id);
          _this.pickup_form_container.show();
        }
        _this.variant_listbox
          .find("option[value='" + variant.id + "']")
          .attr("selected", "");
        _this.enableCartButtons(true);
        _this.enableStockForm(false);
        _this.updatePrices(variant);
        if (_this.show_low_in_stock) {
          _this.updateLowInStock(variant.id);
        }
      } else {
        if (_this.pickup_enabled) {
          _this.pickup_form_container.hide();
        }
        _this.enableCartButtons(false);
        _this.enableStockForm(true);
      }

      // @arren need to trigger custom event for the back in stock snippet here.
      $(_this.form).trigger("variant:changed", { variant: variant });

      if (variant.featured_media) {
        return _this.updateVariantMedia(variant.featured_media.id);
      }
    };

    FrameworkProduct.prototype.enableCartButtons = function (enable) {
      var _this;
      _this = this;
      _this.add_to_cart_button.attr("disabled", !enable);
      if (enable) {
        _this.button_text_container.text(theme.translations.add_to_cart);
        return _this.smart_payment_buttons.show();
      } else {
        _this.button_text_container.text(theme.translations.out_of_stock);
        return _this.smart_payment_buttons.hide();
      }
    };

    FrameworkProduct.prototype.enableStockForm = function (enable) {
      var _this;
      _this = this;
      _this.unavailable_button.prop("disabled", !enable);
      if (enable) {
        return _this.unavailable_container.show();
      } else {
        return _this.unavailable_container.hide();
      }
    };

    FrameworkProduct.prototype.updatePrices = function (variant) {
      var _this, compare_price, unit_price, variant_price;
      _this = this;
      variant_price = theme.utils.formatMoney(variant.price);
      _this.price.html(variant_price);
      if (variant.compare_at_price > variant.price) {
        compare_price = theme.utils.formatMoney(variant.compare_at_price);
        _this.compare_price.html(compare_price);
        _this.compare_price.show();
      } else {
        _this.compare_price.hide();
      }
      if (variant.unit_price_measurement) {
        unit_price = theme.utils.formatMoney(variant.unit_price);
        _this.unit_price.html(unit_price);
        _this.reference_unit.html(
          variant.unit_price_measurement.reference_unit
        );
        if (variant.unit_price_measurement.reference_value === 1) {
          _this.reference_value.hide();
        } else {
          _this.reference_value.html(
            variant.unit_price_measurement.reference_value
          );
          _this.reference_value.show();
        }
        return _this.unit_price_container.show();
      } else {
        return _this.unit_price_container.hide();
      }
    };

    FrameworkProduct.prototype.addToCartListener = function () {
      var _this;
      _this = this;
      if (_this.form.length > 0 && theme.settings.cart_type === "drawer") {
        return _this.form.on("submit", function () {
          _this.form.find(".product-form--error").remove();
          _this.button_container.attr("data-loading", "true");
          theme.partials.Cart.addItem($(this), function (success, error) {
            if (success) {
              return theme.partials.Cart.updateAllHtml(function () {
                return _this.addProductComplete();
              });
            } else {
              _this.form.append(
                "<div class='product-form--error' data-item='paragraph'> " +
                error +
                " </div>"
              );
              return _this.button_container.attr("data-loading", "false");
            }
          });
          return false;
        });
      }
    };

    FrameworkProduct.prototype.addProductComplete = function () {
      var _this;
      _this = this;
      _this.button_container.attr("data-loading", "false");
      return $('[data-off-canvas--open="right-sidebar"]')
        .first()
        .trigger("click");
    };

    FrameworkProduct.prototype.thumbNavigation = function () {
      var _this;
      _this = this;
      return _this.thumbs.on("keypress click", function (event) {
        var clicked_id, clicked_media, current_media;
        if (theme.utils.a11yClick(event)) {
          current_media = _this.root.find(
            '.product-media--featured[data-active="true"] > *'
          );
          current_media.trigger("pause-media");
          clicked_id = $(this).attr("data-id");
          clicked_media = _this.root.find(
            ".product-media--featured[data-id='" + clicked_id + "'] > *"
          );
          _this.updateVariantMedia(clicked_id);
          if (theme.utils.mqs.current_window !== "small") {
            clicked_media.trigger("play-media");
          }
          if (clicked_media.parent().attr("data-media-type") !== "image") {
            return clicked_media.focus();
          }
        }
      });
    };

    FrameworkProduct.prototype.updateVariantMedia = function (variant_id) {
      var _this, variant_image, variant_thumb;
      _this = this;
      _this.main_media.attr("data-active", "false");
      variant_image = _this.main_media.filter("[data-id='" + variant_id + "']");
      variant_image.attr("data-active", "true");
      _this.thumbs.attr("data-active", "false");
      variant_thumb = _this.thumbs.filter("[data-id='" + variant_id + "']");
      variant_thumb.attr("data-active", "true");
      if (_this.zoom_enabled) {
        return _this.imageZoom();
      }
    };

    FrameworkProduct.prototype.imageZoom = function () {
      var _this,
        active_zoom_image,
        left_position,
        top_position,
        wrapper_height,
        wrapper_width,
        x_ratio,
        y_ratio;
      _this = this;
      active_zoom_image = _this.zoom_images.filter(
        "[data-id='" + _this.getActiveImageId() + "']"
      );
      active_zoom_image.css("display", "none");
      _this.media_container.off("mouseenter.Product.imageZoom");
      _this.media_container.off("mouseleave.Product.imageZoom");
      if (
        _this.main_media.length < 1 ||
        theme.utils.mqs.current_window === "small"
      ) {
      } else if (active_zoom_image.length > 0) {
        _this.media_container.attr("data-media-type", "image");
        wrapper_width = _this.media_container.width();
        wrapper_height = _this.media_container.height();
        active_zoom_image.css("width", wrapper_width * _this.magnify);
        active_zoom_image
          .find(".image--root")
          .css("width", wrapper_width * _this.magnify);
        active_zoom_image.find("img").addClass("lazypreload");
        top_position = _this.media_container.offset().top;
        left_position = _this.media_container.offset().left;
        x_ratio =
          (wrapper_width * _this.magnify - wrapper_width) / wrapper_width;
        y_ratio =
          (wrapper_height * _this.magnify - wrapper_height) / wrapper_height;
        _this.media_container.on("mouseenter.Product.imageZoom", function () {
          return active_zoom_image.css("display", "block");
        });
        _this.media_container.on("mouseleave.Product.imageZoom", function () {
          return active_zoom_image.css("display", "none");
        });
        return _this.media_container.on("mousemove", function (event) {
          var relative_left, relative_top;
          relative_left = event.pageX - left_position;
          relative_top = event.pageY - top_position;
          return active_zoom_image.css({
            left: relative_left * -x_ratio,
            top: relative_top * -y_ratio,
          });
        });
      } else {
        return _this.media_container.attr("data-media-type", "");
      }
    };

    FrameworkProduct.prototype.getActiveImageId = function () {
      var _this, active_image, active_image_id;
      _this = this;
      active_image = _this.main_media.filter('[data-active="true"]');
      return (active_image_id = active_image.attr("data-id"));
    };

    FrameworkProduct.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.Product",
        theme.utils.debounce(100, function () {
          return _this.imageZoom();
        })
      );
    };

    FrameworkProduct.prototype.modalCloseListener = function () {
      var _this;
      _this = this;
      return $(window).on("FrameworkModal.afterClose", function () {
        return _this.imageZoom();
      });
    };

    return FrameworkProduct;
  })();

  theme.classes.FrameworkRadios = (function () {
    function FrameworkRadios(root) {
      var _this;
      this.root = root;
      this.setSwatchAppearance = bind(this.setSwatchAppearance, this);
      this.updateLabelOnChange = bind(this.updateLabelOnChange, this);
      this.preventFormSubmitOnEnter = bind(this.preventFormSubmitOnEnter, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_value = _this.root.find(".radios--option-current");
      _this.inputs = _this.root.find('[data-item="radio"]');
      _this.is_swatches = _this.root.data("is-swatches");
      _this.load();
    }

    FrameworkRadios.prototype.load = function () {
      var _this;
      _this = this;
      _this.preventFormSubmitOnEnter();
      if (_this.is_swatches) {
        _this.updateLabelOnChange();
        return _this.setSwatchAppearance();
      }
    };

    FrameworkRadios.prototype.preventFormSubmitOnEnter = function () {
      var _this;
      _this = this;
      return _this.inputs.on("keydown", function (event) {
        if (event.key === "Enter") {
          return event.preventDefault();
        }
      });
    };

    FrameworkRadios.prototype.updateLabelOnChange = function () {
      var _this;
      _this = this;
      return _this.inputs.on("change", function () {
        return _this.current_value.text($(this).val());
      });
    };

    FrameworkRadios.prototype.setSwatchAppearance = function () {
      var _this;
      _this = this;
      return _this.inputs.each(function () {
        var swatch, swatch_color;
        swatch = $(this).siblings(".radios--swatch-button");
        swatch_color = $(this).val().toLowerCase().replace(/\s+/g, "");
        if (theme.swatches[swatch_color] === void 0) {
          return swatch.css("background-color", swatch_color);
        } else if (
          theme.swatches[swatch_color].indexOf("cdn.shopify.com") > -1
        ) {
          return swatch.css(
            "background-image",
            "url(" + theme.swatches[swatch_color] + ")"
          );
        } else {
          return swatch.css("background-color", theme.swatches[swatch_color]);
        }
      });
    };

    return FrameworkRadios;
  })();

  theme.classes.FrameworkSearch = (function () {
    function FrameworkSearch(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.getResults = bind(this.getResults, this);
      this.listenForKeyEntered = bind(this.listenForKeyEntered, this);
      this.getSearchUrl = bind(this.getSearchUrl, this);
      this.searchLinks = bind(this.searchLinks, this);
      this.onOpen = bind(this.onOpen, this);
      _this = this;
      _this.articles = _this.root.find(".search--articles");
      _this.form = _this.root.find("form");
      _this.icon = _this.root.find(".search--icon");
      _this.loading = _this.root.find(".search--loading");
      _this.no_results = _this.root.find(".search--no-results");
      _this.products = _this.root.find(".search--products");
      _this.results = _this.root.find(".search--results");
      _this.text_box = _this.root.find(".search--textbox");
      _this.live_region = _this.root.find("#search-results-announcement");
      _this.toggle_link = _this.root.find(".search--toggle");
      _this.show_articles = _this.root.data("show-articles");
      _this.show_pages = _this.root.data("show-pages");
      _this.view = _this.root.data("view");
      _this.ajax_request = null;
      _this.search_term = null;
      _this.search_url = null;
      _this.close_results_timer = null;
      _this.typing_timer = null;
      _this.article_page_combination = "";
      _this.offCanvas = theme.partials.OffCanvas;
      if (_this.show_articles && _this.show_pages) {
        _this.article_page_combination = "article,page";
      } else if (_this.show_articles) {
        _this.article_page_combination = "article";
      } else if (_this.show_pages) {
        _this.article_page_combination = "page";
      }
      if (_this.view === "modal") {
        _this.searchLinks();
        _this.getSearchUrl();
        _this.listenForKeyEntered();
      }
      _this.resizeListeners();
      _this.matchImageHeights();
    }

    FrameworkSearch.prototype.onOpen = function () {
      var _this, temp_val;
      _this = this;
      _this.text_box.focus();
      temp_val = _this.text_box.val();
      _this.text_box.val("");
      _this.text_box.val(temp_val);
      return _this.text_box.trigger("keyup");
    };

    FrameworkSearch.prototype.searchLinks = function () {
      var _this, triggerElement;
      _this = this;
      triggerElement = null;
      return $("a[href='" + theme.urls.search + "'], button[data-search-trigger]").on(
        "click",
        function () {
          triggerElement = $(this);
          $('[data-trigger="search-modal"]').data("trigger-element", triggerElement).trigger("click");
          _this.onOpen();
          document.querySelector('mobile-nav')?.handleClose();
          return false;
        }
      );
    };

    FrameworkSearch.prototype.getSearchUrl = function () {
      var _this, params, keep, qs;
      _this = this;
      // Build from scratch so current-page query params (theme editor/preview
      // params, variant, view, etc.) don't hijack the alternate search templates
      params = new URLSearchParams(window.location.search);
      keep = new URLSearchParams();
      if (params.get("preview_theme_id")) {
        keep.set("preview_theme_id", params.get("preview_theme_id"));
      }
      qs = keep.toString();
      return (_this.search_url = theme.urls.search + "?" + (qs ? qs + "&" : ""));
    };

    FrameworkSearch.prototype.listenForKeyEntered = function () {
      var _this;
      _this = this;
      return _this.text_box
        .attr("autocomplete", "off")
        .on("keyup paste", function (event) {
          var term;
          clearTimeout(_this.typing_timer);
          term = $(this).val();
          if (term.length < 2 && event.type !== "paste") {
            _this.products.empty();
            _this.articles.empty();
            _this.loading.hide();
            _this.icon.show();
            if (_this.live_region.length) {
              _this.live_region.text("");
            }
            return false;
          }
          _this.loading.show();
          _this.icon.hide();
          return (_this.typing_timer = setTimeout(function () {
            var url;
            clearTimeout(_this.typing_timer);
            url =
              _this.search_url +
              "view=ajax-product&type=product&q=" +
              encodeURIComponent(term) +
              "*";
            _this.getResults(url, term, "product");
            if (_this.show_articles || _this.show_pages) {
              url =
                _this.search_url +
                "view=ajax-article-page&type=" +
                _this.article_page_combination +
                "&q=" +
                encodeURIComponent(term) +
                "*";
              return _this.getResults(url, term, "article");
            }
          }, 750));
        });
    };

    FrameworkSearch.prototype.updateLiveRegion = function () {
      var _this, articleCount, hasNoResults, productCount, totalCount;
      _this = this;
      if (!_this.live_region || !_this.live_region.length) {
        return;
      }
      productCount = _this.products.find(".search--product").length;
      articleCount = _this.articles.find(".search--article").length;
      hasNoResults = _this.products.find(".search--no-results").length > 0 || _this.articles.find(".search--no-results").length > 0;
      totalCount = productCount + articleCount;
      if (totalCount === 0 || hasNoResults) {
        return _this.live_region.text("No results available");
      } else {
        return _this.live_region.text(totalCount + " results available");
      }
    };

    FrameworkSearch.prototype.getResults = function (url, term, type) {
      var _this;
      _this = this;
      _this.products.empty();
      _this.articles.empty();
      $.ajax({
        url: url,
        type: "GET",
        dataType: "html",
        success: function (data) {
          _this.loading.hide();
          _this.icon.show();
          if (type === "product") {
            _this.products.empty();
            _this.products.append(data);
            _this.matchImageHeights();
            return _this.updateLiveRegion();
          } else if (type === "article") {
            _this.articles.empty();
            _this.articles.append(data);
            return _this.updateLiveRegion();
          }
        },
        error: function (jqxhr, textStatus, error) {
          return console.log(
            "search.json Request Failed: " + textStatus + ", " + error
          );
        },
      });
    };

    FrameworkSearch.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.products,
        _this.products.find(".product--root"),
        ".product--image-wrapper"
      );
    };

    FrameworkSearch.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.Search",
        theme.utils.debounce(100, function () {
          return _this.matchImageHeights();
        })
      );
    };

    return FrameworkSearch;
  })();

  theme.classes.FrameworkSections = (function () {
    function FrameworkSections() {
      this.deselectBlock = bind(this.deselectBlock, this);
      this.selectBlock = bind(this.selectBlock, this);
      this.deselectSection = bind(this.deselectSection, this);
      this.selectSection = bind(this.selectSection, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      this.getActiveBlock = bind(this.getActiveBlock, this);
      this.getActiveSection = bind(this.getActiveSection, this);
      this.listeners = bind(this.listeners, this);
      var _this;
      _this = this;
      _this.listeners();
    }

    FrameworkSections.prototype.listeners = function () {
      var _this;
      _this = this;
      _this.load();
      _this.unload();
      _this.selectSection();
      _this.deselectSection();
      _this.selectBlock();
      return _this.deselectBlock();
    };

    FrameworkSections.prototype.getActiveSection = function (event) {
      var _this, active_section;
      _this = this;
      active_section = $(event.target).find("[data-section-id]");
      return active_section;
    };

    FrameworkSections.prototype.getActiveBlock = function (event) {
      var _this, active_block;
      _this = this;
      active_block = $(event.target);
      return active_block;
    };

    FrameworkSections.prototype.load = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:section:load", function (event) {
        var active_section;
        theme.utils.loadJsClasses();
        active_section = _this.getActiveSection(event);
        active_section.triggerHandler("theme:section:load");
        return active_section.find("[data-js-class]").each(function () {
          return $(this).triggerHandler("theme:section:load");
        });
      });
    };

    FrameworkSections.prototype.unload = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:section:unload", function (event) {
        var active_section;
        active_section = _this.getActiveSection(event);
        active_section.triggerHandler("theme:section:unload");
        return active_section.find('[data-js-loaded="true"]').each(function () {
          return $(this).triggerHandler("theme:section:unload");
        });
      });
    };

    FrameworkSections.prototype.selectSection = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:section:select", function (event) {
        var active_section;
        active_section = _this.getActiveSection(event);
        return active_section.triggerHandler("theme:section:select");
      });
    };

    FrameworkSections.prototype.deselectSection = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:section:deselect", function (event) {
        var active_section;
        active_section = _this.getActiveSection(event);
        return active_section.triggerHandler("theme:section:deselect");
      });
    };

    FrameworkSections.prototype.selectBlock = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:block:select", function (event) {
        var active_block;
        active_block = _this.getActiveBlock(event);
        return active_block.triggerHandler("theme:block:select");
      });
    };

    FrameworkSections.prototype.deselectBlock = function () {
      var _this;
      _this = this;
      return $(document).on("shopify:block:deselect", function (event) {
        var active_block;
        active_block = _this.getActiveBlock(event);
        return active_block.triggerHandler("theme:block:deselect");
      });
    };

    return FrameworkSections;
  })();

  theme.classes.FrameworkServiceList = (function () {
    function FrameworkServiceList(root) {
      var _this;
      this.root = root;
      this.balanceColumns = bind(this.balanceColumns, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.section_id = _this.root.data("section-id");
      _this.block_list = _this.root.find(".service-list--blocks");
      _this.blocks = _this.root.find("li");
      _this.blocks_container = _this.root.find(".service-list--container");
      _this.headers = _this.root.find(".service-list--block-header");
      _this.single_column = _this.root.find(".service-list--single-column");
      _this.left_column = _this.root.find(".service-list--left-column");
      _this.right_column = _this.root.find(".service-list--right-column");
      _this.load();
    }

    FrameworkServiceList.prototype.load = function () {
      var _this;
      _this = this;
      return _this.balanceColumns();
    };

    FrameworkServiceList.prototype.balanceColumns = function () {
      var _this,
        assignLoopList,
        isTypeHeader,
        loop_list,
        offset,
        thresholdBreached,
        with_multiple_headers;
      _this = this;
      offset =
        _this.root.data("service-list--show-descriptions") === true ? 75 : 0;
      with_multiple_headers = _this.block_list.length > 1 ? true : false;
      isTypeHeader = function (item) {
        return item.hasClass("service-list--block-header");
      };
      thresholdBreached = function () {
        var left_column_height, right_column_height, single_column_height;
        single_column_height = _this.single_column.outerHeight();
        left_column_height = _this.left_column.outerHeight();
        right_column_height = _this.right_column.outerHeight();
        return (
          left_column_height >=
          parseFloat(right_column_height + single_column_height - offset)
        );
      };
      assignLoopList = function () {
        if (with_multiple_headers) {
          _this.root.attr("data-service-list--has-headers", true);
          return _this.block_list;
        } else {
          _this.left_column.append('<ul class="service-list--blocks"></ul>');
          return _this.blocks;
        }
      };
      loop_list = assignLoopList();
      return loop_list.each(function (index) {
        if (thresholdBreached()) {
          _this.single_column
            .find(".service-list--blocks")
            .appendTo(_this.right_column);
          return;
        } else {
          if (with_multiple_headers) {
            $(this).appendTo(_this.left_column);
          } else {
            if (isTypeHeader($(this))) {
              $(this)
                .find(".service-list--block-header--text")
                .prependTo(_this.blocks_container);
              $(this).remove();
            } else {
              $(this).appendTo(_this.left_column.find(".service-list--blocks"));
            }
          }
        }
        if (
          index === loop_list.length - 1 &&
          _this.right_column.is(":empty") &&
          _this.headers.length > 1
        ) {
          return _this.left_column
            .find(".service-list--blocks")
            .last()
            .appendTo(_this.right_column);
        }
      });
    };

    return FrameworkServiceList;
  })();

  theme.classes.FrameworkSlider = (function () {
    function FrameworkSlider(container1) {
      var _this;
      this.container = container1;
      this.eventListeners = bind(this.eventListeners, this);
      this.pauseMedia = bind(this.pauseMedia, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.updateContextMenu = bind(this.updateContextMenu, this);
      this.autoplay = bind(this.autoplay, this);
      this.formatPaginationNumbers = bind(this.formatPaginationNumbers, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.createSlider = bind(this.createSlider, this);
      this.checkCarouselStatus = bind(this.checkCarouselStatus, this);
      this.load = bind(this.load, this);
      _this = this;
      this.active_index = 0;
      this.autoplay_enabled = this.container.data("autoplay") ? true : false;
      this.autoplay_frequency = 3000;
      this.navigation = this.container.data("navigation") ? true : false;
      this.news_panel = this.container.data("news-panel") ? true : false;
      this.owl = this.container.data("owlCarousel");
      this.pagination_numbers = this.container.data("pagination-numbers")
        ? true
        : false;
      this.slide_length = this.container.children().length;
      _this.load();
    }

    FrameworkSlider.prototype.load = function () {
      var _this;
      _this = this;
      $(window).on("theme.utils.carouselReady", function () {
        _this.createSlider();
        return _this.eventListeners();
      });
      return _this.checkCarouselStatus();
    };

    FrameworkSlider.prototype.checkCarouselStatus = function () {
      var _this;
      _this = this;
      if (theme.utils.carousel_script_status === "loaded") {
        _this.createSlider();
        return _this.eventListeners();
      } else if (theme.utils.carousel_script_status === null) {
        theme.utils.carousel_script_status = "loading";
        return theme.utils.insertScript(theme.assets.carousel, function () {
          theme.utils.carousel_script_status = "loaded";
          return $(window).trigger("theme.utils.carouselReady");
        });
      }
    };

    FrameworkSlider.prototype.createSlider = function () {
      var _this, slider;
      _this = this;
      slider = this.container.owlCarousel({
        singleItem: true,
        navigation: _this.navigation,
        navigationText: false,
        pagination: _this.container.data("pagination") ? true : false,
        paginationNumbers: _this.pagination_numbers,
        scrollPerPageNav: true,
        slideSpeed: 800,
        autoHeight: false,
        autoPlay: _this.autoplay(),
        afterInit: function () {
          return $(window).trigger("slider.ready");
        },
        afterAction: function () {
          _this.active_index = _this.getActiveIndex();
          _this.alignPlayButton();
          _this.updateContextMenu(_this.active_index);
          _this.formatPaginationNumbers();
          return _this.pauseMedia();
        },
      });
      if (_this.navigation) {
        slider
          .find(".owl-prev")
          .html(
            '<svg class="icon--root icon--chevron-left" viewBox="0 0 12 20"> <path d="M2.648 10l8.613-8.614L9.99.114.102 10l9.887 9.886 1.272-1.272z" fill-rule="nonzero" /> </svg>'
          );
        slider
          .find(".owl-next")
          .html(
            '<svg class="icon--root icon--chevron-right" viewBox="0 0 12 20"> <path d="M8.716 10L.102 18.614l1.273 1.272L11.261 10 1.375.114.102 1.386z" fill-rule="nonzero" /> </svg>'
          );
      }
      return slider;
    };

    FrameworkSlider.prototype.getActiveIndex = function () {
      return this.container.find(".owl-pagination .owl-page.active").index();
    };

    FrameworkSlider.prototype.formatPaginationNumbers = function () {
      return this.container
        .find(".owl-page.active .owl-numbers")
        .text(this.active_index + 1 + "/" + this.slide_length);
    };

    FrameworkSlider.prototype.autoplay = function () {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FrameworkSlider.prototype.updateContextMenu = function (index) {
      var context_navigation, type_class;
      if (this.news_panel) {
        type_class =
          "." + this.container.find(".slide").eq(index).data("feed-type");
        context_navigation = this.container
          .closest(".template--index--news")
          .find(".context-navigation");
        context_navigation.find(".item").hide();
        return context_navigation.find(type_class).show();
      }
    };

    FrameworkSlider.prototype.alignPlayButton = function () {
      var play_button, play_button_height, slide, slide_height, video_offset;
      slide = this.container.find(".owl-item").eq(this.active_index);
      play_button = slide.find(".play-button");
      if (play_button.length === 0) {
        return;
      }
      play_button.css("visibility", "hidden");
      if (
        $("body").hasClass("transparent-menu") &&
        $(".header--root").css("position") === "absolute"
      ) {
        slide_height = slide.outerHeight();
        play_button_height = play_button.outerHeight();
        video_offset = (slide_height - play_button_height) / 2;
        play_button.css({
          "margin-top": 0,
          top: video_offset,
        });
      } else {
        play_button.css({
          "margin-top": "-40px",
          top: "50%",
        });
      }
      return play_button.css("visibility", "visible");
    };

    FrameworkSlider.prototype.pauseMedia = function () {
      var _this;
      _this = this;
      return _this.container
        .find(".product-video--root, .product-model--root")
        .trigger("pause-media");
    };

    FrameworkSlider.prototype.eventListeners = function () {
      var _this;
      _this = this;
      this.container.find(".play-button").on("click", function () {
        var video_modal;
        video_modal = new VideoModal($(this).closest(".video"));
        video_modal.open();
        _this.owl.stop();
        return false;
      });
      return this.container
        .find(".owl-pagination .owl-page, .skip-to-next")
        .on("click", function () {
          _this.owl.next();
          return false;
        });
    };

    return FrameworkSlider;
  })();

  theme.classes.FrameworkStickyColumn = (function () {
    function FrameworkStickyColumn(container1, column_a, column_b) {
      this.container = container1;
      this.column_a = column_a;
      this.column_b = column_b;
      this.Listeners = bind(this.Listeners, this);
      this.setColumnPosition = bind(this.setColumnPosition, this);
      this.getAlignment = bind(this.getAlignment, this);
      this.getState = bind(this.getState, this);
      this.resetLargerColumn = bind(this.resetLargerColumn, this);
      this.getSmallerColumn = bind(this.getSmallerColumn, this);
      this.heightsHaveChanged = bind(this.heightsHaveChanged, this);
      this.setHeights = bind(this.setHeights, this);
      this.loadColumns = bind(this.loadColumns, this);
      if (theme.utils.isTouchDevice()) {
        return false;
      }
      this.current_state = "auto";
      this.column_a_height = 0;
      this.column_b_height = 0;
      this.loadColumns();
    }

    FrameworkStickyColumn.prototype.loadColumns = function () {
      var _this;
      _this = this;
      return theme.utils.imagesLoaded(_this.container, function () {
        _this.Listeners();
        return _this.setColumnPosition();
      });
    };

    FrameworkStickyColumn.prototype.setHeights = function () {
      this.column_a_height = this.column_a.outerHeight();
      return (this.column_b_height = this.column_b.outerHeight());
    };

    FrameworkStickyColumn.prototype.heightsHaveChanged = function () {
      if (this.column_a.outerHeight() !== this.column_a_height) {
        this.setHeights();
        return true;
      }
      if (this.column_b.outerHeight() !== this.column_b_height) {
        this.setHeights();
        return true;
      }
      return false;
    };

    FrameworkStickyColumn.prototype.getSmallerColumn = function () {
      if (this.column_a_height < this.column_b_height) {
        return this.column_a;
      } else {
        return this.column_b;
      }
    };

    FrameworkStickyColumn.prototype.resetLargerColumn = function () {
      if (this.column_a_height > this.column_b_height) {
        return this.column_a.css({
          position: "relative",
          top: "auto",
          bottom: "auto",
        });
      } else {
        return this.column_b.css({
          position: "relative",
          top: "auto",
          bottom: "auto",
        });
      }
    };

    FrameworkStickyColumn.prototype.getState = function (
      scroll_pos,
      window_height,
      column
    ) {
      var column_height, height_for_bottom, overflowing_column, state;
      state = "auto";
      if (theme.utils.mqs.current_window === "small") {
        return "auto";
      }
      column_height = column.outerHeight();
      if (window_height > column_height) {
        overflowing_column = true;
      }
      if (scroll_pos < this.container.offset().top) {
        state = "auto";
      }
      if (overflowing_column) {
        height_for_bottom = column_height;
      } else {
        height_for_bottom = window_height;
      }
      if (
        scroll_pos + height_for_bottom >
        this.container.offset().top + this.container.outerHeight()
      ) {
        state = "absolute-bottom";
      } else if (
        scroll_pos > this.container.offset().top &&
        overflowing_column
      ) {
        state = "fixed-top";
      } else if (
        window_height < column_height &&
        scroll_pos + window_height >
        this.container.offset().top + column.outerHeight()
      ) {
        state = "fixed-bottom";
      }
      return state;
    };

    FrameworkStickyColumn.prototype.getAlignment = function (column) {
      if (column.hasClass("column-a")) {
        return "left";
      } else if (column.hasClass("column-b")) {
        return "right";
      }
    };

    FrameworkStickyColumn.prototype.setColumnPosition = function () {
      var _this, align, column, state;
      _this = this;
      _this.setHeights();
      column = _this.getSmallerColumn();
      state = _this.getState($(window).scrollTop(), $(window).height(), column);
      align = _this.getAlignment(column);
      if (state === "auto" && this.current_state !== "auto") {
        this.current_state = "auto";
        column.css({
          position: "relative",
          top: "auto",
          bottom: "auto",
        });
      } else if (
        state === "fixed-bottom" &&
        this.current_state !== "fixed-bottom"
      ) {
        this.current_state = "fixed-bottom";
        column.css({
          position: "fixed",
          top: "auto",
          bottom: 0,
        });
      } else if (state === "fixed-top" && this.current_state !== "fixed-top") {
        this.current_state = "fixed-top";
        column.css({
          position: "fixed",
          top: 0,
          bottom: "auto",
        });
      } else if (
        state === "absolute-bottom" &&
        this.current_state !== "absolute-bottom"
      ) {
        this.current_state = "absolute-bottom";
        column.css({
          position: "absolute",
          top: "auto",
          bottom: 0,
        });
      }
      if (align === "right") {
        return column.css({
          right: 0,
        });
      }
    };

    FrameworkStickyColumn.prototype.Listeners = function () {
      var _this;
      _this = this;
      // $(window).on("scroll", function () {
      //   return _this.setColumnPosition();
      // });
      setInterval(function () {
        if (_this.heightsHaveChanged()) {
          _this.resetLargerColumn();
          return _this.setColumnPosition();
        }
      }, 250);
      return $(window).on("resize", function () {
        _this.resetLargerColumn();
        return _this.setColumnPosition();
      });
    };

    return FrameworkStickyColumn;
  })();

  theme.classes.FrameworkTabOrder = (function () {
    function FrameworkTabOrder(mobile_order, desktop_order) {
      var _this;
      this.mobile_order = mobile_order;
      this.desktop_order = desktop_order;
      this.resizeListener = bind(this.resizeListener, this);
      this.disableFocus = bind(this.disableFocus, this);
      this.enableCustomFocus = bind(this.enableCustomFocus, this);
      this.updateOrderList = bind(this.updateOrderList, this);
      this.detectTabDirection = bind(this.detectTabDirection, this);
      this.getElementList = bind(this.getElementList, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.tab_forwards = null;
      _this.mobile_order_elements = _this.getElementList(_this.mobile_order);
      _this.desktop_order_elements = _this.getElementList(_this.desktop_order);
      _this.load();
    }

    FrameworkTabOrder.prototype.load = function () {
      var _this;
      _this = this;
      _this.detectTabDirection();
      _this.updateOrderList();
      _this.enableCustomFocus();
      return _this.resizeListener();
    };

    FrameworkTabOrder.prototype.getElementList = function (order_list) {
      var _this, order_list_elements;
      _this = this;
      if (order_list) {
        order_list_elements = [];
        order_list.forEach(function (container_class) {
          if ($(container_class).length > 0) {
            return order_list_elements.push($(container_class).first());
          }
        });
        return order_list_elements;
      } else {
        return false;
      }
    };

    FrameworkTabOrder.prototype.detectTabDirection = function () {
      var _this;
      _this = this;
      return $(document).on("keydown", function (event) {
        _this.tab_forwards = true;
        if (event.which === 9 && event.shiftKey) {
          _this.tab_forwards = false;
        }
        return true;
      });
    };

    FrameworkTabOrder.prototype.updateOrderList = function () {
      var _this;
      _this = this;
      if (theme.utils.mqs.current_window === "small") {
        _this.current_order_elements = _this.mobile_order_elements;
        return (_this.previous_order_elements = _this.desktop_order_elements);
      } else {
        _this.current_order_elements = _this.desktop_order_elements;
        return (_this.previous_order_elements = _this.mobile_order_elements);
      }
    };

    FrameworkTabOrder.prototype.enableCustomFocus = function () {
      var _this;
      _this = this;
      if (!_this.current_order_elements) {
        return;
      }
      return _this.current_order_elements.forEach(function (element, index) {
        return element.on("focusout", function (event) {
          var lost_focus, move_to;
          if (!theme.utils.tabbing) {
            return;
          }
          lost_focus = $(this).has(event.relatedTarget).length === 0;
          if (lost_focus && _this.tab_forwards) {
            if (index + 1 < _this.current_order_elements.length) {
              move_to = _this.current_order_elements[index + 1];
              return move_to.find(":focusable").first().focus();
            }
          } else if (lost_focus) {
            if (index - 1 >= 0) {
              move_to = _this.current_order_elements[index - 1];
              return move_to.find(":focusable").last().focus();
            }
          }
        });
      });
    };

    FrameworkTabOrder.prototype.disableFocus = function () {
      var _this;
      _this = this;
      if (!_this.previous_order_elements) {
        return;
      }
      return _this.previous_order_elements.forEach(function (element, index) {
        return element.off("focusout");
      });
    };

    FrameworkTabOrder.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return $(window).on("theme.utils.mqs.updated", function () {
        _this.updateOrderList();
        _this.enableCustomFocus();
        return _this.disableFocus();
      });
    };

    return FrameworkTabOrder;
  })();

  theme.classes.FrameworkUtils = (function () {
    function FrameworkUtils() {
      this.isTouchDevice = bind(this.isTouchDevice, this);
      this.loadJsClasses = bind(this.loadJsClasses, this);
      this.detectTabbing = bind(this.detectTabbing, this);
      var _this;
      _this = this;
      _this.carousel_script_status = null;
      _this.google_maps_script_status = null;
      _this.mqs = new theme.classes.FrameworkMediaQueries();
      _this.detectTabbing();
    }

    FrameworkUtils.prototype.a11yClick = function (event) {
      var code;
      if (event.type === "click") {
        return true;
      } else if (event.type === "keypress") {
        code = event.charCode || event.keyCode;
        if (code === 32) {
          event.preventDefault();
        }
        if (code === 32 || code === 13) {
          return true;
        }
      }
      return false;
    };

    FrameworkUtils.prototype.detectTabbing = function () {
      var _this;
      _this = this;
      $(window).on("click load", function () {
        _this.tabbing = false;
        return $("body").attr("data-tabbing", _this.tabbing);
      });
      return $(window).on("keydown", function (event) {
        if (
          event.which === 9 ||
          event.which === 37 ||
          event.which === 38 ||
          event.which === 39 ||
          event.which === 40 ||
          event.which === 27
        ) {
          _this.tabbing = true;
          return $("body").attr("data-tabbing", _this.tabbing);
        }
      });
    };

    FrameworkUtils.prototype.stylesheetLoaded = function () {
      var stylesheetPromise;
      return (stylesheetPromise = new Promise(function (resolve) {
        var link;
        link = document.querySelector(
          "link[href='" + theme.assets.stylesheet + "']"
        );
        if (link.loaded) {
          resolve();
        }
        return link.addEventListener("load", function () {
          return setTimeout(resolve, 0);
        });
      }));
    };

    FrameworkUtils.prototype.debounce = function (delay, fn) {
      var timeoutId;
      timeoutId = void 0;
      return function () {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(fn.bind(this), delay, arguments);
      };
    };

    FrameworkUtils.prototype.imagesLoaded = function (selector, callback) {
      var count, images_length;
      count = 0;
      images_length = selector.find('img[data-sizes="auto"]').length;
      if (images_length < 1) {
        callback();
        return;
      }
      return selector.on("lazybeforeunveil", function (event) {
        return $(event.target).on("load", function () {
          count++;
          if (count === images_length) {
            return callback();
          }
        });
      });
    };

    FrameworkUtils.prototype.loadJsClasses = function () {
      var _this;
      _this = this;
      $(document).watchFor("[data-js-class", function ($el) {
        $el.each(function () {
          var js_class, partial_class;
          js_class = $(this).attr("data-js-class");
          if ($(this).attr("data-js-loaded") !== "true") {
            partial_class = theme.classes[js_class];
            if (typeof partial_class !== "undefined") {
              theme.partials[js_class] = new partial_class($(this));
              return $(this).attr("data-js-loaded", "true");
            }
          }
        });
      });
    };

    FrameworkUtils.prototype.matchImageHeights = function (
      container,
      items,
      image_class
    ) {
      var _this, greatest_image_height, items_per_row, row_items;
      _this = this;
      items_per_row = Math.round(
        container.width() / items.first().outerWidth()
      );
      greatest_image_height = 0;
      row_items = $();
      items.find(image_class).css("height", "auto");
      items.find(".placeholder--root").css("height", "auto");
      return items.each(function (index) {
        var this_height;
        if ($(this).find(".image--root").length > 0) {
          this_height = $(this)
            .find(image_class + " .image--root")
            .outerHeight();
        } else {
          this_height = $(this).find(".placeholder--root").outerHeight();
        }
        row_items = row_items.add($(this));
        if (this_height > greatest_image_height) {
          greatest_image_height = this_height;
        }
        if (
          index % items_per_row === items_per_row - 1 ||
          index + 1 === items.length
        ) {
          row_items
            .find(image_class + ", .placeholder--root")
            .height(greatest_image_height);
          greatest_image_height = 0;
          return (row_items = $());
        }
      });
    };

    FrameworkUtils.prototype.insertStylesheet = function (src) {
      var _this, stylesheet;
      _this = this;
      stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = src;
      return document.head.appendChild(stylesheet);
    };

    FrameworkUtils.prototype.insertScript = function (src, callback) {
      var _this, script;
      _this = this;
      script = document.createElement("script");
      script.src = src;
      if (callback) {
        script.onload = callback;
      }
      return document.body.appendChild(script);
    };

    FrameworkUtils.prototype.formatMoney = function (raw_amount) {
      var _this, formatWithSeperators, formatted_amount, money_format, regex;
      _this = this;
      regex = /\{\{\s*(\w+)\s*\}\}/;
      money_format = theme.shop.money_format.match(regex)[1];
      formatWithSeperators = function (
        amount_in_cents,
        decimal_places,
        swap_seperators
      ) {
        var amount_components,
          cents,
          cents_seperator,
          dollars,
          thousand_seperator;
        thousand_seperator = swap_seperators ? "." : ",";
        cents_seperator = swap_seperators ? "," : ".";
        amount_components = (amount_in_cents / 100)
          .toFixed(decimal_places)
          .split(".");
        cents = amount_components[1]
          ? cents_seperator + amount_components[1]
          : "";
        dollars = amount_components[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousand_seperator
        );
        return dollars + cents;
      };
      switch (money_format) {
        case "amount":
          formatted_amount = formatWithSeperators(raw_amount, 2, false);
          break;
        case "amount_no_decimals":
          formatted_amount = formatWithSeperators(raw_amount, 0, false);
          break;
        case "amount_with_comma_separator":
          formatted_amount = formatWithSeperators(raw_amount, 2, true);
          break;
        case "amount_no_decimals_with_comma_separator":
          formatted_amount = formatWithSeperators(raw_amount, 0, true);
      }
      return theme.shop.money_format.replace(regex, formatted_amount);
    };

    FrameworkUtils.prototype.isTouchDevice = function () {
      var _this;
      _this = this;
      if (window.matchMedia("(pointer: coarse)").matches) {
        return true;
      } else {
        return false;
      }
    };

    FrameworkUtils.prototype.isNaN = function (num) {
      var _this;
      _this = this;
      return num !== num;
    };

    return FrameworkUtils;
  })();

  theme.classes.FrameworkXMenu = (function () {
    function FrameworkXMenu(root) {
      var _this;
      this.root = root;
      this.slideUp = bind(this.slideUp, this);
      this.slideDown = bind(this.slideDown, this);
      this.arrangeMegaNav = bind(this.arrangeMegaNav, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.checkOverlap = bind(this.checkOverlap, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.debugging = false;
      _this.state = "closed";
      _this.parent_links = _this.root.find(".x-menu--level-1--link > a");
      _this.sub_menu_links = _this.root.find(
        '.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a'
      );
      _this.sub_menu_items = _this.sub_menu_links.parent().find("ul a");
      _this.parents_with_sub_menu = _this.sub_menu_links.parent();
      _this.overlap_parent = _this.root.data("x-menu--overlap-parent");
      _this.load();
    }

    FrameworkXMenu.prototype.load = function () {
      var _this;
      _this = this;
      _this.arrangeMegaNav();
      _this.listeners();
      _this.checkOverlap();
      return _this.resizeListeners();
    };

    FrameworkXMenu.prototype.listeners = function () {
      var _this;
      _this = this;
      _this.parents_with_sub_menu.on("mouseenter.XMenu", function () {
        return _this.slideDown($(this).find("> a"));
      });
      _this.parents_with_sub_menu.on("mouseleave.XMenu", function () {
        return _this.slideUp();
      });
      _this.parent_links.on("focus", function () {
        return _this.slideUp();
      });
      _this.sub_menu_links.on("focus", function () {
        return _this.slideDown($(this));
      });
      return _this.sub_menu_links.on("touchstart.XMenu", function (event) {
        event.preventDefault();
        if ($(this).parent().attr("data-x-menu--open") === "true") {
          return _this.slideUp();
        } else {
          return _this.slideDown($(this));
        }
      });
    };

    FrameworkXMenu.prototype.checkOverlap = function () {
      var _this,
        center_index,
        center_item,
        center_item_left_edge,
        center_item_right_edge,
        center_item_width,
        container,
        container_width,
        first_center_child,
        last_center_child,
        left_break_point,
        left_item,
        right_item,
        right_item_edge;
      _this = this;
      if (
        theme.utils.isTouchDevice() &&
        theme.utils.mqs.current_window !== "large"
      ) {
        _this.root.attr("data-x-menu--overlap", "true");
        return false;
      }
      _this.root.attr("data-x-menu--overlap", "false");
      center_item = _this.root;
      if (_this.overlap_parent === 1) {
        center_item = center_item.parent();
      } else if (_this.overlap_parent === 2) {
        center_item = center_item.parent().parent();
      }
      container = center_item.parent();
      center_index = center_item.index();
      left_item = false;
      if (center_index > 1) {
        left_item = container.children().eq(center_index - 1);
      }
      right_item = false;
      if (center_index + 1 < container.children().length) {
        right_item = container.children().eq(center_index + 1);
      }
      container_width = container.width();
      center_item_width = _this.root.outerWidth();
      if (left_item) {
        first_center_child = center_item.find("> :first-child");
        center_item_left_edge = first_center_child.offset().left - 1;
        left_break_point = (container_width - center_item_width) / 2;
        if (left_edge >= center_item_left_edge) {
          _this.root.attr("data-x-menu--overlap", "true");
        }
      }
      if (right_item) {
        last_center_child = center_item.find("> :last-child");
        center_item_right_edge =
          last_center_child.outerWidth() + last_center_child.offset().left + 1;
        right_item_edge = right_item.offset().left;
        if (center_item_right_edge >= right_item_edge) {
          return _this.root.attr("data-x-menu--overlap", "true");
        }
      }
    };

    FrameworkXMenu.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.XMenu",
        _this.debounce(100, function () {
          return _this.checkOverlap();
        })
      );
    };

    FrameworkXMenu.prototype.debounce = function (delay, fn) {
      var timeoutId;
      timeoutId = void 0;
      return function () {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(fn.bind(this), delay, arguments);
      };
    };

    FrameworkXMenu.prototype.arrangeMegaNav = function () {
      var _this, mega_navs;
      _this = this;
      if (_this.parents_with_sub_menu.length === 0) {
        return false;
      }
      mega_navs = _this.root.find(
        '[data-x-menu--depth="3"] .x-menu--level-2--container'
      );
      return mega_navs.each(function () {
        var container, single_parents, single_parents_container;
        container = $(this);
        single_parents = container.find('[data-x-menu--single-parent="true"]');
        if (single_parents.length > 0) {
          single_parents_container = $(
            '<div class="x-menu--single-parents"></div>'
          ).insertAfter(container.find(".x-menu--bg"));
          return single_parents_container
            .append("<ul>")
            .find("ul")
            .append(single_parents);
        }
      });
    };

    FrameworkXMenu.prototype.slideDown = function (link, delay) {
      var _this, display_type, link_wrapper, menu_height, sub_menu;
      if (delay == null) {
        delay = false;
      }
      _this = this;
      clearTimeout(_this.timer);
      link_wrapper = link.parent();
      if (
        link_wrapper.attr("data-x-menu--open") === "true" ||
        _this.state === "closing"
      ) {
        return false;
      }
      _this.slideUp(false);
      if (delay && delay !== "complete") {
        _this.timer = setTimeout(function () {
          return _this.slideDown(link, "complete");
        }, delay);
      } else {
        link.closest(".x-menu--level-1--link").find(".icon--chevron-up").show();
        link
          .closest(".x-menu--level-1--link")
          .find(".icon--chevron-down")
          .hide();
        link.closest(".x-menu--level-1--link").find(".icon--minus").show();
        link.closest(".x-menu--level-1--link").find(".icon--plus").hide();
        _this.state = "open";
        link_wrapper.attr("data-x-menu--open", "true");
        link.attr("aria-expanded", "true");
        sub_menu = link
          .closest(".x-menu--level-1--link")
          .find(".x-menu--level-2--container");
        display_type = "block";
        if (link_wrapper.attr("data-x-menu--depth") === "3") {
          display_type = "flex";
        }
        sub_menu.velocity("stop");
        sub_menu.css({
          height: "auto",
          display: display_type,
        });
        sub_menu.find(".x-menu--level-2--list").css({
          display: display_type,
        });
        menu_height = sub_menu.outerHeight();
        sub_menu.css({
          height: 0,
          opacity: 1,
        });
        sub_menu.velocity(
          {
            height: [menu_height, 0],
          },
          {
            queue: false,
            duration: 600,
            easing: "easeOutExpo",
          }
        );
      }
    };

    FrameworkXMenu.prototype.slideUp = function (delay) {
      var _this, link, link_wrapper, sub_menu;
      if (delay == null) {
        delay = 300;
      }
      _this = this;
      if (_this.debugging) {
        return false;
      }
      link_wrapper = _this.parents_with_sub_menu.filter(
        '[data-x-menu--open="true"]'
      );
      link = link_wrapper.find("> a");
      if (link_wrapper.attr("data-x-menu--open") === "false") {
        return false;
      }
      if (delay) {
        return (_this.timer = setTimeout(function () {
          return _this.slideUp(false);
        }, delay));
      } else {
        link.closest(".x-menu--level-1--link").find(".icon--chevron-up").hide();
        link
          .closest(".x-menu--level-1--link")
          .find(".icon--chevron-down")
          .show();
        link.closest(".x-menu--level-1--link").find(".icon--minus").hide();
        link.closest(".x-menu--level-1--link").find(".icon--plus").show();
        sub_menu = link
          .closest(".x-menu--level-1--link")
          .find(".x-menu--level-2--container");
        link_wrapper.attr("data-x-menu--open", "false");
        link.attr("aria-expanded", "false");
        return sub_menu.velocity(
          {
            opacity: 0,
          },
          {
            begin: function () {
              return (_this.state = "closing");
            },
            complete: function () {
              sub_menu.css({
                display: "none",
              });
              return (_this.state = "closed");
            },
            duration: 200,
          }
        );
      }
    };

    return FrameworkXMenu;
  })();

  theme.classes.FrameworkYMenu = (function () {
    function FrameworkYMenu(root) {
      var _this;
      this.root = root;
      this.slideRight = bind(this.slideRight, this);
      this.slideLeft = bind(this.slideLeft, this);
      this.adjustHeight = bind(this.adjustHeight, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.state = "closed";
      _this.sub_menu_links = _this.root
        .find(".icon--chevron-right--small")
        .parent();
      _this.back_links = _this.root.find(".y-menu--back-link a");
      _this.regular_links = _this.root.find(
        '.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])'
      );
      _this.timer = null;
      _this.load();
    }

    FrameworkYMenu.prototype.load = function () {
      var _this;
      _this = this;
      return _this.listeners();
    };

    FrameworkYMenu.prototype.listeners = function () {
      var _this;
      _this = this;
      _this.regular_links.on("click", function () {
        var href;
        href = $(this).attr("href");
        if (href.indexOf("#") !== -1) {
          if (theme.partials.OffCanvas.state === "left-open") {
            theme.partials.OffCanvas.closeLeft();
          } else if (theme.partials.OffCanvas.state === "right-open") {
            theme.partials.OffCanvas.closeRight();
          }
          setTimeout(function () {
            return (window.location.href = href);
          }, 450);
        }
      });
      _this.sub_menu_links.on("click", function () {
        _this.slideLeft($(this));
        return false;
      });
      return _this.back_links.on("click", function () {
        _this.slideRight($(this));
        return false;
      });
    };

    FrameworkYMenu.prototype.adjustHeight = function (open_list) {
      var _this, current_height, open_list_height;
      _this = this;
      _this.root.css({
        height: "auto",
      });
      current_height = _this.root.outerHeight();
      open_list_height = open_list.outerHeight();
      if (open_list.css("position") === "absolute") {
        open_list.css("position", "relative");
        open_list_height = open_list.outerHeight();
        open_list.css("position", "absolute");
      }
      return _this.root.velocity({
        height: open_list_height,
      });
    };

    FrameworkYMenu.prototype.slideLeft = function (link) {
      var _this, sub_menu;
      _this = this;
      sub_menu = link.closest("li").find("ul").first();
      sub_menu.css({
        display: "block",
      });
      _this.adjustHeight(sub_menu);
      return sub_menu.velocity({
        translateX: ["-100%", 0],
      });
    };

    FrameworkYMenu.prototype.slideRight = function (link) {
      var _this, container, parent_container;
      _this = this;
      container = link.closest("ul");
      parent_container = container.parent().closest("ul");
      _this.adjustHeight(parent_container);
      return container.velocity({
        translateX: [0, "-100%"],
      });
    };

    return FrameworkYMenu;
  })();

  Accordion = (function () {
    function Accordion() {
      $(".accordion.headings").each(function () {
        return $(this)
          .add($(this).next(".accordion.content"))
          .wrapAll("<div class='accordion-wrapper'/>");
      });
      $(".accordion.headings li").wrapInner('<div class="trigger"></div>');
      $(".accordion.headings li .trigger").append('<div class="bg"></div>');
      $(".accordion-wrapper").each(function () {
        var accordion_content, accordion_heading;
        accordion_heading = $(this).find(".accordion.headings > li");
        accordion_content = $(this).find(".accordion.content > li");
        accordion_heading.first().addClass("active");
        accordion_content.each(function (index) {
          var content;
          content = $("<div class='content'>" + $(this).html() + "</div>");
          return content.appendTo(accordion_heading.eq(index));
        });
        accordion_content.remove();
        $(this).find(".content").first().show();
        return $(this)
          .find(".trigger")
          .on("click", function () {
            var panels, this_panel;
            panels = $(this).closest(".accordion").find(".content");
            this_panel = $(this).closest("li").find(".content");
            panels.not(this_panel).slideUp(200);
            this_panel.slideDown(200);
            $(this).closest(".accordion").find("li").removeClass("active");
            return $(this).closest("li").addClass("active");
          });
      });
    }

    return Accordion;
  })();

  theme.classes.Article = (function (superClass) {
    extend(Article, superClass);

    function Article() {
      return Article.__super__.constructor.apply(this, arguments);
    }

    return Article;
  })(theme.classes.FrameworkArticle);

  theme.classes.Blog = (function (superClass) {
    extend(Blog, superClass);

    function Blog() {
      return Blog.__super__.constructor.apply(this, arguments);
    }

    return Blog;
  })(theme.classes.FrameworkBlog);

  theme.classes.Cart = (function (superClass) {
    extend(Cart, superClass);

    function Cart() {
      this.updateTotalsComplete = bind(this.updateTotalsComplete, this);
      return Cart.__super__.constructor.apply(this, arguments);
    }

    Cart.prototype.updateTotalsComplete = function (count) {
      return $(".header--cart-number").attr("data-item-count", count);
    };

    return Cart;
  })(theme.classes.FrameworkCart);

  theme.classes.Disclosure = (function (superClass) {
    extend(Disclosure, superClass);

    function Disclosure() {
      return Disclosure.__super__.constructor.apply(this, arguments);
    }

    return Disclosure;
  })(theme.classes.FrameworkDisclosure);

  theme.classes.FeaturedVideo = (function (superClass) {
    extend(FeaturedVideo, superClass);

    function FeaturedVideo() {
      return FeaturedVideo.__super__.constructor.apply(this, arguments);
    }

    return FeaturedVideo;
  })(theme.classes.FrameworkFeaturedVideo);

  theme.classes.Footer = (function (superClass) {
    extend(Footer, superClass);

    function Footer() {
      return Footer.__super__.constructor.apply(this, arguments);
    }

    return Footer;
  })(theme.classes.FrameworkFooter);

  FullscreenSlider = (function () {
    function FullscreenSlider(slider_element) {
      this.eventListeners = bind(this.eventListeners, this);
      this.alignPlayButton = bind(this.alignPlayButton, this);
      this.alignCaption = bind(this.alignCaption, this);
      this.isFirstSlider = bind(this.isFirstSlider, this);
      this.getActiveIndex = bind(this.getActiveIndex, this);
      this.autoplay = bind(this.autoplay, this);
      this.removeDuplicateVideoModals = bind(
        this.removeDuplicateVideoModals,
        this
      );
      this.createSlider = bind(this.createSlider, this);
      this.checkCarouselStatus = bind(this.checkCarouselStatus, this);
      this.load = bind(this.load, this);
      var _this, slide_parent;
      _this = this;
      this.el = slider_element;
      slide_parent = this.el.closest(".slider");
      this.autoplay_enabled = slide_parent.data("autoplay");
      if (slide_parent.find(".slide").length < 2) {
        this.autoplay_enabled = false;
      }
      this.autoplay_frequency = slide_parent.data("rotateFrequency");
      this.transition_style = slide_parent.data("transitionStyle");
      _this.load();
    }

    FullscreenSlider.prototype.load = function () {
      var _this;
      _this = this;
      $(window).on("theme.utils.carouselReady", function () {
        _this.removeDuplicateVideoModals();
        _this.createSlider();
        return (_this.owl = $(".owl-carousel").data("owlCarousel"));
      });
      return _this.checkCarouselStatus();
    };

    FullscreenSlider.prototype.checkCarouselStatus = function () {
      var _this;
      _this = this;
      if (theme.utils.carousel_script_status === "loaded") {
        _this.removeDuplicateVideoModals();
        _this.createSlider();
        return (_this.owl = $(".owl-carousel").data("owlCarousel"));
      } else if (theme.utils.carousel_script_status === null) {
        theme.utils.carousel_script_status = "loading";
        return theme.utils.insertScript(theme.assets.carousel, function () {
          theme.utils.carousel_script_status = "loaded";
          return $(window).trigger("theme.utils.carouselReady");
        });
      }
    };

    FullscreenSlider.prototype.createSlider = function () {
      var slider, slider_options;
      slider = this;
      slider_options = {
        singleItem: true,
        navigation: false,
        paginationNumbers: false,
        scrollPerPageNav: true,
        slideSpeed: 800,
        pagination: true,
        autoHeight: true,
        autoPlay: slider.autoplay(),
        afterInit: function () {
          return slider.eventListeners();
        },
        afterAction: function () {
          slider.alignCaption();
          return slider.alignPlayButton();
        },
      };
      if (this.transition_style !== "default") {
        slider_options["transitionStyle"] = this.transition_style;
      }
      return slider.el.owlCarousel(slider_options);
    };

    FullscreenSlider.prototype.removeDuplicateVideoModals = function () {
      var _this;
      _this = this;
      return $(".modal.video:gt(0)").remove();
    };

    FullscreenSlider.prototype.autoplay = function () {
      if (this.autoplay_enabled) {
        return this.autoplay_frequency;
      }
      return false;
    };

    FullscreenSlider.prototype.getActiveIndex = function () {
      return this.el.find(".owl-pagination .owl-page.active").index();
    };

    FullscreenSlider.prototype.isFirstSlider = function () {
      var current_section_id, first_section, first_section_id;
      first_section = $(".layout--main-content").children("div:first");
      first_section_id = first_section.find(".slider").data("sectionId");
      current_section_id = this.el.closest(".slider").data("sectionId");
      if (first_section.hasClass("section--slideshow")) {
        return current_section_id === first_section_id;
      }
      return false;
    };

    FullscreenSlider.prototype.alignCaption = function () {
      var caption,
        caption_height,
        caption_width,
        slide,
        slide_padding,
        top_offset;
      slide = this.el.find(".owl-item").eq(this.getActiveIndex());
      caption = slide.find(".caption");
      caption.css("visibility", "hidden");
      caption_height = caption.outerHeight();
      caption_width = caption.outerWidth();
      slide_padding = 30;
      if (
        theme.utils.transparentMenuIsEnabled() &&
        this.isFirstSlider() === true
      ) {
        top_offset = $(".header--root").outerHeight();
      } else {
        top_offset = 0;
      }
      return theme.utils.imagesLoaded(slide.find("img").first(), function () {
        var left_offset, middle_top, slide_height, slide_width;
        slide_height = slide.outerHeight();
        slide_width = slide.outerWidth();
        if (caption.hasClass("top")) {
          caption.css("top", top_offset + slide_padding);
        } else if (caption.hasClass("middle")) {
          middle_top =
            top_offset + (slide_height - top_offset - caption_height) / 2;
          caption.css("top", middle_top);
        }
        if (caption.hasClass("center")) {
          left_offset = (slide_width - caption_width) / 2;
          caption.css("left", left_offset);
        }
        return caption.css("visibility", "visible");
      });
    };

    FullscreenSlider.prototype.alignPlayButton = function () {
      var play_button, slide;
      slide = this.el.find(".owl-item").eq(this.getActiveIndex());
      play_button = slide.find(".play-button");
      play_button.css("visibility", "hidden");
      if (
        theme.utils.transparentMenuIsEnabled() &&
        $(".header--root").css("position") === "absolute"
      ) {
        theme.utils.imagesLoaded(slide.find("img").first(), function () {
          var play_button_height, slide_height, video_offset;
          slide_height = slide.outerHeight();
          play_button_height = play_button.outerHeight();
          video_offset = (slide_height - play_button_height) / 2;
          return play_button.css({
            "margin-top": 0,
            top: video_offset,
          });
        });
      } else {
        play_button.css({
          "margin-top": "-40px",
          top: "50%",
        });
      }
      return play_button.css("visibility", "visible");
    };

    FullscreenSlider.prototype.eventListeners = function () {
      var slider;
      slider = this;
      this.el.find(".play-button").on("click", function () {
        var video_modal;
        video_modal = new VideoModal($(this).closest(".video"));
        video_modal.open();
        slider.owl.stop();
        return false;
      });
      this.el.find(".owl-pagination .owl-page").on("click", function () {
        return slider.owl.stop();
      });
      return $(document).on(
        "header.transparentMenuIsUpdated",
        slider.alignCaption
      );
    };

    return FullscreenSlider;
  })();

  theme.classes.Header = (function () {
    function Header(root) {
      var _this;
      this.root = root;
      this.searchAndAccount = bind(this.searchAndAccount, this);
      this.moveLocalizationForm = bind(this.moveLocalizationForm, this);
      this.moveYMenu = bind(this.moveYMenu, this);
      this.sectionListeners = bind(this.sectionListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.disclosure_inputs = _this.root.find('[data-item="disclosure"]');
      _this.load();
    }

    Header.prototype.load = function () {
      var _this;
      _this = this;
      _this.searchAndAccount();
      _this.sectionListeners();
      _this.moveYMenu();
      if (_this.disclosure_inputs.length > 0) {
        return _this.moveLocalizationForm();
      }
    };

    Header.prototype.sectionListeners = function () {
      var _this;
      _this = this;
      return _this.root.on("theme:section:load", function () {
        theme.partials.OffCanvas.unload();
        return theme.partials.OffCanvas.load();
      });
    };

    Header.prototype.moveYMenu = function () {
      var _this;
      _this = this;
      $(".mobile-nav--menu").empty();
      return $(".y-menu").appendTo(".mobile-nav--menu");
    };

    Header.prototype.moveLocalizationForm = function () {
      var _this;
      _this = this;
      $(".mobile-nav--localization").empty();
      return $(".header--localization-for-off-canvas form").appendTo(
        ".mobile-nav--localization"
      );
    };

    Header.prototype.searchAndAccount = function () {
      var _this;
      _this = this;
      $(".account-open").on("click", function () {
        $(this)
          .closest(".menu")
          .fadeOut(100, function () {
            return $(".account-container").fadeIn(200);
          });
        return false;
      });
      return $(".account-close").on("click", function () {
        $(".account-container").fadeOut(100, function () {
          return $(".search-account .menu").fadeIn(200);
        });
        return false;
      });
    };

    return Header;
  })();

  HorizontalTabs = (function () {
    function HorizontalTabs() {
      $(".tabs-horizontal.headings").each(function () {
        return $(this)
          .add($(this).next(".tabs.content"))
          .wrapAll("<div class='tabs-wrapper horizontal'/>");
      });
      $(".tabs-horizontal.headings li").wrapInner(
        '<div class="trigger" tabindex="0"></div>'
      );
      $(".tabs-horizontal.headings li .trigger").append(
        '<div class="bg"></div>'
      );
      $(".tabs-wrapper.horizontal").each(function () {
        var tab_content, tab_headings;
        tab_headings = $(this).find(".headings > li");
        tab_content = $(this).find(".tabs.content > li");
        tab_content.first().addClass("active");
        tab_headings.first().addClass("active");
        return tab_headings.on("click keydown", function () {
          if (event.type === "keydown" && event.key !== "Enter") {
            return;
          }
          tab_headings.removeClass("active");
          tab_content.removeClass("active");
          $(this).addClass("active");
          return tab_content.eq($(this).index()).addClass("active");
        });
      });
    }

    return HorizontalTabs;
  })();

  theme.classes.OffCanvas = (function (superClass) {
    extend(OffCanvas, superClass);

    function OffCanvas() {
      this.closeRight = bind(this.closeRight, this);
      return OffCanvas.__super__.constructor.apply(this, arguments);
    }

    OffCanvas.prototype.closeRight = function () {
      var _this;
      _this = this;
      OffCanvas.__super__.closeRight.apply(this, arguments);
      if (_this.right_sidebar_view === "cart") {
        return $(
          "[data-off-canvas--open='right-sidebar'][data-off-canvas--view='cart'] a"
        ).focus();
      } else {
        return $(
          "[data-off-canvas--open='right-sidebar'][data-off-canvas--view='pickup']"
        ).focus();
      }
    };

    return OffCanvas;
  })(theme.classes.FrameworkOffCanvas);

  theme.classes.PasswordPage = (function (superClass) {
    extend(PasswordPage, superClass);

    function PasswordPage() {
      return PasswordPage.__super__.constructor.apply(this, arguments);
    }

    return PasswordPage;
  })(theme.classes.FrameworkPasswordPage);

  Popup = (function () {
    function Popup(clazz) {
      var checkContentOverflow,
        closeDialog,
        eventListeners,
        fillPopupDialog,
        getCustomClasses,
        getImage,
        getNewsletter,
        getPageContent,
        getSocialIcons,
        getWrapper,
        hideMask,
        ieCenter,
        isExpired,
        mask,
        maskIsActive,
        modal,
        modal_clazz,
        openDialog,
        passesExpiration,
        resetExpiration,
        showMask,
        storeExpiration;
      this.clazz = clazz;
      modal = null;
      modal_clazz = this.clazz;
      mask = $(".popup-modal-mask");
      storeExpiration = function () {
        var date, e, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * theme.popup.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires,
        };
        try {
          return (localStorage[theme.popup.storage_key] =
            JSON.stringify(object));
        } catch (error1) {
          e = error1;
          return false;
        }
      };
      resetExpiration = function () {
        localStorage.removeItem(theme.popup.storage_key);
        return storeExpiration();
      };
      isExpired = function () {
        var expires, now, object;
        object = JSON.parse(localStorage[theme.popup.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function () {
        var passed;
        passed = false;
        if (
          Storage === "undefined" ||
          localStorage === null ||
          theme.popup.test_mode
        ) {
          passed = true;
        } else if (
          typeof localStorage[theme.popup.storage_key] === "undefined"
        ) {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function () {
        return (
          $(".popup-modal").is(":visible") ||
          ($(".modal-mask").length > 0 && $(".modal-mask").is(":visible"))
        );
      };
      showMask = function () {
        mask.show();
        return $("body").addClass("modal-on");
      };
      hideMask = function () {
        mask.hide();
        return $("body").removeClass("modal-on");
      };
      getImage = function () {
        // if (theme.popup.show_image_enabled === false) {
        //   return "";
        // }
        // if (theme.popup.image_link.length > 0) {
        //   return $("<div class='popup-image'> <a href='" + theme.popup.image_link + "'>" + theme.popup.show_image_url + "</a> </div>");
        // } else {
        //   return $('<div class="popup-image">').append(theme.popup.show_image_url);
        // }
      };
      getNewsletter = function () {
        let mobileMenuOpen = document.querySelector(".js-mobile-nav-trigger")?.getAttribute("aria-expanded") === "true";
        var subscribe_module;
        if (theme.popup.newsletter_enabled === false || mobileMenuOpen) {
          return "";
        }
        subscribe_module = $("<div id='subscribe_module'></div>").append(
          $(".popup--root")
        );
        return subscribe_module;
      };
      getSocialIcons = function () {
        if (theme.popup.social_icons_enabled === false) {
          return "";
        }
        return $(".footer--social-icons").clone();
      };
      getCustomClasses = function () {
        var class_list;
        class_list = "";
        class_list +=
          theme.popup.show_image_enabled === true
            ? " has-image"
            : " has-no-image";
        class_list +=
          theme.popup.page_content.length > 0
            ? " has-page-content"
            : " has-no-page-content";
        class_list += theme.popup.newsletter_enabled
          ? " has-newsletter"
          : " has-no-newsletter";
        class_list += theme.popup.social_icons_enabled
          ? " has-social-icons"
          : " has-no-social-icons";
        return class_list;
      };
      getWrapper = function () {
        return (
          "<dialog class='" +
          modal_clazz +
          " popup-modal " +
          getCustomClasses() +
          "' />"
        );
      };
      getPageContent = function () {
        var page_content;
        page_content = null;
        if (theme.popup.page_content.length < 1) {
          return "";
        }
        $.getJSON(
          "/pages/" + theme.popup.page_content + ".json",
          function (data, textStatus) {
            return (page_content =
              "<div class='page-contents'>" + data.page.body_html + "</div>");
          }
        );
        return page_content;
      };
      fillPopupDialog = function () {
        var dialog, getInnerContent, render;
        dialog = {
          wrapper: getWrapper(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          // image: getImage()
        };
        getInnerContent = function () {
          if (
            theme.popup.page_content.length < 1 &&
            theme.popup.newsletter_enabled === false &&
            theme.popup.social_icons_enabled === false
          ) {
            return "";
          }
          return $("<div class='inner'/>").append(
            dialog.body,
            dialog.newsletter,
            dialog.social_icons
          );
        };
        render = function () {
          let mobileMenuOpen = document.querySelector(".js-mobile-nav-trigger")?.getAttribute("aria-expanded") === "true";
          if (mobileMenuOpen) return;

          $("body").append($(dialog.wrapper).append(getInnerContent()));
          return openDialog();
        };
        if (theme.popup.page_content.length > 0) {
          return $.getJSON(
            "/pages/" + theme.popup.page_content + ".json",
            function (data, textStatus) {
              dialog["body"] =
                "<div class='page-contents'>" + data.page.body_html + "</div>";
              return render();
            }
          );
        } else {
          return render();
        }
      };
      checkContentOverflow = function () {
        return setTimeout(function () {
          if (modal.length > 0 && $(".popup-modal-mask").is(":visible")) {
            return theme.utils.imagesLoaded(modal, function () {
              var dialog_height;
              dialog_height = $(
                "dialog[class*='" + modal_clazz + "']:last-of-type"
              ).outerHeight();
              if (dialog_height >= $(window).height()) {
                return $("body").addClass("modal-unfix");
              } else {
                return $("body").removeClass("modal-unfix");
              }
            });
          }
        }, 0);
      };
      ieCenter = function () {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px",
        });
      };
      openDialog = function () {
        console.log("openDialog");
        modal = $("dialog[class*='" + modal_clazz + "']");
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        trapFocus(modal);
        return showMask();
      };
      trapFocus = function (modal) {
        const focusableElements = modal.find(
          'a, button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        ) || [];
        if (focusableElements.length > 0) {
          return focusableElements.first().focus();
        }
      };
      eventListeners = function () {
        var removeAnimation;
        removeAnimation = function (event) {
          if (event.originalEvent.animationName === "modal-close") {
            if (modal_clazz === "popup") {
              return modal.remove();
            } else {
              return modal.removeClass("closed, completed");
            }
          } else {
            return modal.addClass("completed").removeClass("opened");
          }
        };
        $(".popup-modal").on("click", function (event) {
          event.stopPropagation();
          if (event.target === this) {
            return closeDialog();
          }
        });

        $(".popup-modal-close, .js-popup-close").on("click", closeDialog);

        mask.on("click", closeDialog);
        modal.on(
          "animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd",
          removeAnimation
        );
        $(window).on("resize", checkContentOverflow);
        $(document).on("keydown", function (event) {
          if (modal.hasClass("completed") && event.keyCode === 27) {
            return closeDialog();
          }
        });
        return $("dialog.popup-modal #contact_form").on(
          "submit",
          function (event) {
            var form;
            form = this;
            modal = $(this).closest(".popup-modal");
            modal.find(".error, .success").remove();
            event.preventDefault();
            if (modal.find('input[type="email"]').val().length === 0) {
              modal
                .find(".inner")
                .prepend(
                  "<p class='error'>" +
                  theme.translations.newsletter_email_blank +
                  "</p>"
                );
              return false;
            } else {
              form.submit();
            }
            return false;
          }
        );
      };
      closeDialog = function () {
        modal.addClass("closed").removeClass("completed").removeClass("opened");
        return hideMask();
      };
      if (
        theme.popup.enabled &&
        passesExpiration() &&
        (theme.popup.page_content.length > 0 ||
          theme.popup.newsletter_enabled ||
          theme.popup.show_image_enabled ||
          theme.popup.social_icons_enabled)
      ) {
        setTimeout(function () {
          if (!(maskIsActive() === true || $(".popup-modal-mask").length < 1)) {
            return fillPopupDialog();
          }
        }, theme.popup.seconds_until * 1000);
      }
    }

    return Popup;
  })();

  theme.classes.ProductGrid = (function () {
    function ProductGrid(root) {
      var _this;
      this.root = root;
      this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
      this.listeners = bind(this.listeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.detectOnboarding = bind(this.detectOnboarding, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.items = _this.root.find(".product--root");
      _this.onboarding = _this.detectOnboarding();
      _this.in_slider = _this.root.data("in-slider");
      _this.load();
    }

    ProductGrid.prototype.load = function () {
      var _this;
      _this = this;
      _this.listeners();
      _this.hoverImagesLoaded();
      if (!_this.in_slider) {
        return _this.matchImageHeights();
      }
    };

    ProductGrid.prototype.detectOnboarding = function () {
      var _this;
      _this = this;
      if (_this.items.first().find(".placeholder").length) {
        return true;
      }
      return false;
    };

    ProductGrid.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.root,
        _this.items,
        ".product--image-wrapper"
      );
    };

    ProductGrid.prototype.listeners = function () {
      var _this;
      _this = this;
      if (!_this.in_slider) {
        return $(window).on(
          "resize.ProductGrid",
          theme.utils.debounce(100, function () {
            return _this.matchImageHeights();
          })
        );
      }
    };

    ProductGrid.prototype.hoverImagesLoaded = function () {
      var _this;
      _this = this;
      return _this.items.filter('[data-hover-image="true"]').each(function () {
        var product;
        product = $(this);
        return theme.utils.imagesLoaded(product, function () {
          return product.attr("data-hover-image", "loaded");
        });
      });
    };

    return ProductGrid;
  })();

  theme.classes.ProductModel = (function (superClass) {
    extend(ProductModel, superClass);

    function ProductModel() {
      return ProductModel.__super__.constructor.apply(this, arguments);
    }

    return ProductModel;
  })(theme.classes.FrameworkProductModel);

  theme.classes.ProductRecommendations = (function (superClass) {
    extend(ProductRecommendations, superClass);

    function ProductRecommendations() {
      return ProductRecommendations.__super__.constructor.apply(
        this,
        arguments
      );
    }

    return ProductRecommendations;
  })(theme.classes.FrameworkProductRecommendations);

  ProductSlider = (function () {
    function ProductSlider(root) {
      var _this;
      this.root = root;
      this.listeners = bind(this.listeners, this);
      this.afterUpdate = bind(this.afterUpdate, this);
      this.createSlider = bind(this.createSlider, this);
      this.checkCarouselStatus = bind(this.checkCarouselStatus, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.product_grid = _this.root.find(".product-grid--root");
      _this.product_item = _this.root.find(".product--root");
      _this.load();
      _this.listeners();
    }

    ProductSlider.prototype.load = function () {
      var _this;
      _this = this;
      $(window).on("theme.utils.carouselReady", function () {
        return _this.createSlider();
      });
      return _this.checkCarouselStatus();
    };

    ProductSlider.prototype.checkCarouselStatus = function () {
      var _this;
      _this = this;
      if (theme.utils.carousel_script_status === "loaded") {
        return _this.createSlider();
      } else if (theme.utils.carousel_script_status === null) {
        theme.utils.carousel_script_status = "loading";
        return theme.utils.insertScript(theme.assets.carousel, function () {
          theme.utils.carousel_script_status = "loaded";
          return $(window).trigger("theme.utils.carouselReady");
        });
      }
    };

    ProductSlider.prototype.createSlider = function () {
      var _this;
      _this = this;
      _this.product_grid.owlCarousel({
        items: 4,
        navigation: true,
        scrollPerPage: true,
        slideSpeed: 800,
        lazyLoad: false,
        pagination: false,
        navigationText: false,
        afterUpdate: _this.afterUpdate(),
      });
      return _this.product_item.show();
    };

    ProductSlider.prototype.afterUpdate = function () {
      var _this;
      _this = this;
      return $(window).trigger("ProductSlider.afterUpdate");
    };

    ProductSlider.prototype.listeners = function () {
      var _this;
      _this = this;
      return $(window).on(
        "resize.ProductGrid",
        theme.utils.debounce(100, function () {
          return _this.loadCarousel;
        })
      );
    };

    return ProductSlider;
  })();

  theme.classes.ProductVideo = (function (superClass) {
    extend(ProductVideo, superClass);

    function ProductVideo() {
      return ProductVideo.__super__.constructor.apply(this, arguments);
    }

    return ProductVideo;
  })(theme.classes.FrameworkProductVideo);

  theme.classes.Product = (function (superClass) {
    extend(Product, superClass);

    function Product(root) {
      var _this;
      this.root = root;
      this.initTabOrder = bind(this.initTabOrder, this);
      this.updateVariantMedia = bind(this.updateVariantMedia, this);
      this.mobileModalHandler = bind(this.mobileModalHandler, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.mobile_tab_order = [
        ".product-page--title-n-vendor",
        ".product-page--media",
        ".product-page--cart-form",
        ".product-page--description",
        ".product-share--root",
        ".product-recommendations--root",
        ".footer--root",
      ];
      Product.__super__.constructor.apply(this, arguments);
    }

    Product.prototype.load = function () {
      var _this;
      _this = this;
      Product.__super__.load.apply(this, arguments);
      _this.mobileModalHandler();
      _this.initTabOrder();
      return _this.root.on("theme:section:load", function () {
        new Accordion();
        new HorizontalTabs();
        return new VerticalTabs();
      });
    };

    Product.prototype.mobileModalHandler = function () {
      var _this, modal_links;
      _this = this;
      modal_links = _this.media_container.find(".modal--link");
      return modal_links.on("click", function (event) {
        if (theme.utils.mqs.current_window === "small") {
          return event.stopImmediatePropagation();
        }
      });
    };

    Product.prototype.updateVariantMedia = function (variant_id) {
      var _this, variant_image;
      _this = this;
      Product.__super__.updateVariantMedia.apply(this, arguments);
      variant_image = _this.main_media.filter("[data-id='" + variant_id + "']");
      return _this.media_container.attr(
        "data-media-type",
        variant_image.attr("data-media-type")
      );
    };

    Product.prototype.initTabOrder = function () {
      var _this;
      _this = this;
      return new theme.classes.FrameworkTabOrder(_this.mobile_tab_order, null);
    };

    return Product;
  })(theme.classes.FrameworkProduct);

  theme.classes.Radios = (function (superClass) {
    extend(Radios, superClass);

    function Radios() {
      return Radios.__super__.constructor.apply(this, arguments);
    }

    return Radios;
  })(theme.classes.FrameworkRadios);

  theme.classes.Sections = (function (superClass) {
    extend(Sections, superClass);

    function Sections() {
      this.deselectSection = bind(this.deselectSection, this);
      this.selectBlock = bind(this.selectBlock, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      return Sections.__super__.constructor.apply(this, arguments);
    }

    Sections.prototype.load = function (event) {
      var _this;
      _this = this;
      Sections.__super__.load.apply(this, arguments);
      return $(document).on("shopify:section:load", function (event) {
        var section_wrapper;
        section_wrapper = $(event.target).closest(".shopify-section");
        section_wrapper.css("min-height", "2000px");
        if (section_wrapper.hasClass("section--slideshow")) {
          new FullscreenSlider($(event.target).find(".slides"));
        } else if (section_wrapper.hasClass("section--featured-collection")) {
          new ProductSlider($(event.target).find(".product-slider"));
        } else if (section_wrapper.hasClass("section--header")) {
          setTimeout(function () {
            if ($(".slider").length > 0) {
              return $(document).trigger("header.transparentMenuIsUpdated");
            }
          }, 0);
        } else if (section_wrapper.hasClass("section--products")) {
          $(document).trigger("set-option-selectors");
        }
        return section_wrapper.css("min-height", "auto");
      });
    };

    Sections.prototype.unload = function (event) {
      var _this;
      _this = this;
      Sections.__super__.unload.apply(this, arguments);
      return $(document).on("shopify:section:unload", function (event) {
        var mask, section_wrapper;
        section_wrapper = $(event.target).closest(".shopify-section");
        if (section_wrapper.hasClass("section--featured-collection")) {
          return setTimeout(function () {
            if ($(".section--featured-collection").length === 0) {
              return $(window).off("resize.ProductSlider");
            }
          }, 0);
        } else if (section_wrapper.hasClass("section--products")) {
          mask = $(".popup-modal-mask");
          $(".size-chart").remove();
          if (mask.is(":visible")) {
            return mask.trigger("click");
          }
        } else if (section_wrapper.hasClass("section--slideshow")) {
          return setTimeout(function () {
            if ($(".slider").length === 0) {
              return $(document).off("header.transparentMenuIsUpdated");
            }
          }, 0);
        }
      });
    };

    Sections.prototype.selectBlock = function () {
      var _this;
      _this = this;
      Sections.__super__.selectBlock.apply(this, arguments);
      return $(document).on("shopify:block:select", function (event) {
        var section_wrapper, slide_selected;
        section_wrapper = $(event.target).closest(".shopify-section");
        if (section_wrapper.hasClass("section--slideshow")) {
          slide_selected = section_wrapper.find(".slide").index(event.target);
          return $(event.target)
            .closest(".owl-carousel")
            .trigger("owl.jumpTo", slide_selected)
            .trigger("owl.stop");
        }
      });
    };

    Sections.prototype.deselectSection = function () {
      var _this;
      _this = this;
      Sections.__super__.deselectSection.apply(this, arguments);
      return $(document).on("shopify:section:deselect", function (event) {
        var section_wrapper, should_autoplay, slider;
        section_wrapper = $(event.target).closest(".shopify-section");
        if (section_wrapper.hasClass("section--slideshow")) {
          should_autoplay = section_wrapper.find(".slider").data("autoplay");
          if (should_autoplay === true) {
            slider = section_wrapper.find(".slides");
            return slider.trigger(
              "owl.play",
              section_wrapper.find(".slider").data("rotateFrequency")
            );
          }
        }
      });
    };

    return Sections;
  })(theme.classes.FrameworkSections);

  theme.classes.ServiceList = (function (superClass) {
    extend(ServiceList, superClass);

    function ServiceList() {
      return ServiceList.__super__.constructor.apply(this, arguments);
    }

    return ServiceList;
  })(theme.classes.FrameworkServiceList);

  VerticalTabs = (function () {
    function VerticalTabs() {
      $(".tabs-vertical.headings").each(function () {
        return $(this)
          .add($(this).next(".tabs.content"))
          .wrapAll("<div class='tabs-wrapper vertical'/>");
      });
      $(".tabs-vertical.headings li").wrapInner('<div class="trigger"></div>');
      $(".tabs-vertical.headings li .trigger").append('<div class="bg"></div>');
      $(".tabs-wrapper.vertical").each(function () {
        var tab_content, tab_headings, tab_wrapper;
        tab_wrapper = $(this);
        tab_headings = $(this).find(".headings > li");
        tab_content = $(this).find(".tabs.content > li");
        tab_content.first().addClass("active");
        tab_headings.first().addClass("active");
        return tab_headings.on("click", function () {
          tab_headings.removeClass("active");
          tab_content.removeClass("active");
          $(this).addClass("active");
          tab_content.eq($(this).index()).addClass("active");
          if (theme.utils.scroll_to_active_item) {
            if (theme.utils.mqs.current_window === "small") {
              return $("html, body").animate(
                {
                  scrollTop:
                    tab_wrapper.offset().top +
                    tab_wrapper.find(".headings").outerHeight() -
                    50,
                },
                "slow"
              );
            } else {
              return $("html, body").animate(
                {
                  scrollTop: tab_wrapper.offset().top - 50,
                },
                "slow"
              );
            }
          }
        });
      });
    }

    return VerticalTabs;
  })();

  VideoModal = (function () {
    function VideoModal(video) {
      this.createIframe = bind(this.createIframe, this);
      this.extractVideoId = bind(this.extractVideoId, this);
      this.extractVideoType = bind(this.extractVideoType, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.centerPosition = bind(this.centerPosition, this);
      this.close = bind(this.close, this);
      this.open = bind(this.open, this);
      this.opened = false;
      this.video = video;
      this.modal = $(".video.modal");
      this.player_button = video.find(".player-button");
      this.src_url = video.find(".play-button").attr("href");
      this.type = this.extractVideoType();
      this.id = this.extractVideoId();
      this.iframe = this.createIframe();
      this.caption = video.find(".caption");
    }

    VideoModal.prototype.open = function () {
      this.opened = true;
      this.modal.find(".flex-video").append(this.iframe);
      if (this.caption.length > 0) {
        this.modal.find(".caption").append(this.caption.html());
        this.modal.addClass("wide");
      } else {
        this.modal.find(".player").removeClass("large-8");
        this.modal.find(".caption").hide();
        this.modal.removeClass("wide");
      }
      this.player_button.hide();
      $(".modal-mask").show();
      this.modal.find(".close").show();
      this.modal.fadeIn();
      this.centerPosition();
      $(".modal").fadeIn(0);
      return this.eventListeners();
    };

    VideoModal.prototype.close = function () {
      this.opened = false;
      this.modal.find(".flex-video").empty();
      this.modal.find(".caption").empty();
      this.modal.hide();
      $(".modal-mask").fadeOut();
      if (this.caption.length === 0) {
        this.modal.find(".player").addClass("large-8");
        return this.modal.find(".caption").show();
      }
    };

    VideoModal.prototype.centerPosition = function () {
      if ($(window).height() < this.modal.outerHeight()) {
        return this.modal.css({
          position: "absolute",
          top: "30px",
          "margin-top": 0,
          "margin-left": -(this.modal.outerWidth() / 2),
        });
      } else {
        return this.modal.css({
          position: "fixed",
          top: "50%",
          "margin-top": -(this.modal.outerHeight() / 2),
          "margin-left": -(this.modal.outerWidth() / 2),
        });
      }
    };

    VideoModal.prototype.eventListeners = function () {
      var modal;
      modal = this;
      this.modal.find(".close").on("click", function () {
        return modal.close();
      });
      $(window).on("resize", function () {
        return modal.centerPosition();
      });
      $(document).on("keydown", function (event) {
        if (modal.opened) {
          if (event.keyCode === 27) {
            return modal.close();
          }
        }
      });
      $(".modal-mask").on("click", function () {
        return modal.close();
      });
      return this.player_button.on("click", function () {
        return false;
      });
    };

    VideoModal.prototype.extractVideoType = function () {
      var matches, re;
      re =
        /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(this.src_url);
      if (matches) {
        return "youtube";
      } else {
        re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        matches = re.exec(this.src_url);
        if (matches) {
          return "vimeo";
        }
      }
      return false;
    };

    VideoModal.prototype.extractVideoId = function () {
      var match, regExp;
      if (this.type === "youtube") {
        regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = this.src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (this.type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = this.src_url.match(regExp);
        if (match) {
          return match[2];
        }
      }
    };

    VideoModal.prototype.createIframe = function () {
      if (this.type === "youtube") {
        return (
          "<iframe src='//www.youtube.com/embed/" +
          this.id +
          "?autoplay=1&rel=0' frameborder='0' allowfullscreen ></iframe>"
        );
      } else if (this.type === "vimeo") {
        return (
          "<iframe src='//player.vimeo.com/video/" +
          this.id +
          "?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>"
        );
      }
    };

    return VideoModal;
  })();

  theme.classes.XMenu = (function (superClass) {
    extend(XMenu, superClass);

    function XMenu(root) {
      var _this;
      this.root = root;
      this.slideDown = bind(this.slideDown, this);
      this.hideHeader = bind(this.hideHeader, this);
      this.showHeader = bind(this.showHeader, this);
      this.headerListeners = bind(this.headerListeners, this);
      this.isHeaderTransparent = bind(this.isHeaderTransparent, this);
      _this = this;
      _this.header = $(".header--root");
      _this.header_bg = _this.header.find(".header--bg");
      _this.header_timer = null;
      _this.transparent_header = _this.isHeaderTransparent();
      XMenu.__super__.constructor.apply(this, arguments);
      _this.headerListeners();
    }

    XMenu.prototype.isHeaderTransparent = function () {
      var _this;
      _this = this;
      if ($(".header--root").attr("data-header-menu-transparent") === "true") {
        return true;
      } else {
        return false;
      }
    };

    XMenu.prototype.headerListeners = function () {
      var _this;
      _this = this;
      _this.parents_with_sub_menu.on("mouseenter", function () {
        return clearTimeout(_this.header_timer);
      });
      _this.header.on("mouseenter touchstart", function () {
        clearTimeout(_this.header_timer);
        return _this.showHeader();
      });
      return _this.header.on("mouseleave", function () {
        return (_this.header_timer = setTimeout(function () {
          return _this.hideHeader();
        }, 500));
      });
    };

    XMenu.prototype.showHeader = function () {
      var _this;
      _this = this;
      if (parseInt(_this.header_bg.css("opacity")) !== 0) {
        return;
      }
      return _this.header_bg.velocity(
        {
          opacity: [0.95],
        },
        {
          duration: 400,
          queue: false,
        }
      );
    };

    XMenu.prototype.hideHeader = function () {
      var _this;
      _this = this;
      if (
        _this.parents_with_sub_menu.filter('[data-main-menu--open="true"]')
          .length > 0
      ) {
        return false;
      }
      _this.header_bg.velocity(
        {
          opacity: 0,
        },
        {
          duration: 400,
        }
      );
      return _this.slideUp();
    };

    XMenu.prototype.slideDown = function (link, delay) {
      var _this, opacity;
      if (delay == null) {
        delay = false;
      }
      _this = this;
      if (delay !== "complete") {
        opacity = Math.round(parseFloat(_this.header_bg.css("opacity")) * 100);
        if (opacity < 90 && _this.transparent_header) {
          delay = 400;
        }
      }
      return XMenu.__super__.slideDown.call(this, link, delay);
    };

    return XMenu;
  })(theme.classes.FrameworkXMenu);

  theme.classes.Utils = (function (superClass) {
    extend(Utils, superClass);

    function Utils() {
      var _this;
      _this = this;
      Utils.__super__.constructor.apply(this, arguments);
    }

    Utils.prototype.transparentMenuIsEnabled = function () {
      return $("body").find("[data-header-menu-transparent=true]").length > 0;
    };

    return Utils;
  })(theme.classes.FrameworkUtils);

  new (Main = (function () {
    function Main() {
      this.configureSliders = bind(this.configureSliders, this);
      this.configureColumns = bind(this.configureColumns, this);
      this.configureLinks = bind(this.configureLinks, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      _this.has_slider = $(".slider, .product-slider").length > 0;
      _this.on_index_page = $("body").hasClass("template-index");
      _this.on_template_page = $("body").hasClass("template-page");
      $(function () {
        return _this.load();
      });
    }

    Main.prototype.load = function () {
      var _this;
      _this = this;
      new Popup("popup");
      new Accordion();
      new HorizontalTabs();
      new VerticalTabs();
      theme.sections = new theme.classes.Sections();
      theme.utils = new theme.classes.Utils();
      theme.utils.stylesheetLoaded().then(function () {
        theme.utils.loadJsClasses();
        return $("body").attr("data-assets-loaded", "true");
      });
      _this.configureLinks();
      if (_this.on_template_page) {
        return _this.configureColumns();
      } else if (_this.on_index_page && _this.has_slider) {
        return _this.configureSliders();
      }
    };

    Main.prototype.configureLinks = function () {
      $('[data-item="hidden-text"] a').attr("tabindex", "-1");
      if (theme.utils.enable_external_links) {
        return $('a[href^="http"]')
          .not("a[href^='" + theme.urls.shop + "']")
          .attr("target", "_blank");
      }
    };

    Main.prototype.configureColumns = function () {
      var page_content;
      page_content = $('.template-page--main [data-item="rte-content"]');
      if (
        page_content.find(".left-side-column").length ||
        page_content.find(".right-side-column").length
      ) {
        if (
          page_content.find(".left-side-column").length &&
          page_content.find(".right-side-column").length
        ) {
          page_content.wrapInner(
            "<div class='main-column with-2-sidebars'></div>"
          );
          $(".left-side-column").addClass("with-2-sidebars");
          $(".right-side-column").addClass("with-2-sidebars");
        } else {
          page_content.wrapInner("<div class='main-column'></div>");
        }
        $(".left-side-column").prependTo(page_content);
        return $(".right-side-column").appendTo(page_content);
      }
    };

    Main.prototype.configureSliders = function () {
      return theme.utils.insertScript(theme.assets.carousel, function () {
        theme.utils.carousel_script_status = "loaded";
        $(".slider").each(function () {
          return new FullscreenSlider($(this).find(".slides"));
        });
        return $(".product-slider").each(function () {
          return new ProductSlider($(this));
        });
      });
    };

    return Main;
  })())();
}).call(this);

// =======================
// Custom JS Modules [aa]
// =======================

const elementsExist = function (elementList) {
  let allElementsExist = true;

  elementList.forEach((element) => {
    if (!$(element).length) allElementsExist = false;
  });

  return allElementsExist;
};

// article page
const article = (function () {
  const selectors = {
    articleContent: "[data-article-content]",
    articleProductLinks: "[data-article-content] a",
    quickShopModal: "[data-quickshop-modal]",
    quickShopContent: ".js-quickshop-content",
    quickShopModalOverlay: ".js-quickshop-overlay",
    closeButton: "[data-close-modal]",
  };

  const init = function () {
    if (!elementsExist([selectors.articleContent])) return;

    initializeEventListeners();
  };

  const initializeEventListeners = function () {
    $(selectors.articleProductLinks).on("click", handleProductLinkClick);
    $(selectors.quickShopModal).on("click", selectors.closeButton, closeModal);
    $(selectors.quickShopModalOverlay).on("click", closeModal);
  };

  const handleProductLinkClick = function (e) {
    e.preventDefault();

    let $this = $(this);
    let href = $this.attr("href");

    getProductContent(href);
  };

  const getProductContent = function (href) {
    $.ajax({
      url: href + "?view=quick-shop",
      method: "GET",
      success: function (response) {
        if (response.includes("data-fishwife-quickshop")) {
          $(selectors.quickShopContent).html(response);
          openModal();
        } else {
          window.open(href, "_blank");
        }
      },
      error: function (error) {
        window.open(href, "_blank");
      },
    });
  };

  const openModal = function () {
    $(selectors.quickShopModal).show();
    $(selectors.quickShopModal).addClass("active");
  };

  const closeModal = function () {
    $(selectors.quickShopModal).removeClass("active");

    setTimeout(function () {
      $(selectors.quickShopModal).hide();
      $(selectors.quickShopContent).empty();
    }, 300);
  };

  return {
    init,
  };
})();

const homepageVideoSync = (function () {
  const settings = {
    mainContent: ".layout--main-content",
    video: ".js-video-hero",
  };

  const getTopOffset = function () {
    return $(settings.mainContent).position().top;
  };

  const syncVideoHeight = function ($video) {
    let topOffset = getTopOffset();
    let maxHeight = `calc(100vh - ${topOffset}px)`;

    $video.css("--max-height", maxHeight);
  };

  const init = function () {
    let $video = $(settings.video);
    if ($video.length) {
      syncVideoHeight($video);
    }
  };

  return {
    init: init,
  };
})();

class RevealAnimation {
  constructor({ targetClass, triggerClass, footerSelector }) {
    this.targetClass = targetClass;
    this.triggerClass = triggerClass;
    this.footerSelector = footerSelector;

    this.$targets = $("." + targetClass);
  }

  init() {
    if (!elementsExist([this.$targets])) return;

    this.initializeAnimationsObserver();
  }

  initializeAnimationsObserver() {
    if (typeof IntersectionObserver === "function") {
      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };

      let observer = new IntersectionObserver(this.observeAnimations, options);

      this.$targets.each(function (index, target) {
        observer.observe(target);
      });
    } else {
      this.$targets.addClass(this.triggerClass);
      this.$targets.removeClass(this.targetClass);
    }
  }

  observeAnimations(entries, observer) {
    entries.forEach((entry) => {
      let $target = $(entry.target);

      if (!$target.hasClass(this.triggerClass) && entry.isIntersecting) {
        let delay = 0;

        if (screen.availWidth < 567 && $target.data("mobileDelay")) {
          delay = $target.data("mobileDelay");
        } else {
          delay = $target.data("delay");
        }

        if (delay) {
          setTimeout(function () {
            $target.addClass("animate__animated");
            $target.removeClass("animate");
          }, parseInt(delay));
        } else {
          $target.addClass("animate__animated");
          $target.removeClass("animate");
        }
      }
    });
  }
}

const triggerAnimations = () => {
  const config = {
    targetClass: "animate",
    triggerClass: "animate__animated",
    footerSelector: ".section-footer",
  };

  const animations = new RevealAnimation(config);
  animations.init();
};

const textRotator = (function () {
  const settings = {
    rotatorText: ".js-rotate-text",
    rotatorSpan: ".js-rotate-text-span",
    rotatorSVG: ".js-rotate-svg",
    rotatorIcon: ".js-rotate-icon",
    length: 0,
    currentIndex: 0,
    intervalId: 0,
  };

  const init = function () {
    settings.length = $(settings.rotatorText).length;

    if (settings.length) {
      settings.intervalId = setInterval(textRotate, 2500);
    }
  };

  const textRotate = function () {
    settings.currentIndex += 1;

    if (settings.currentIndex === settings.length) {
      settings.currentIndex = 0;
    }

    let currentText = $(settings.rotatorText).eq(settings.currentIndex);
    let currentIcon = $(settings.rotatorIcon).eq(settings.currentIndex);

    $(settings.rotatorText).not(currentText).hide();
    $(settings.rotatorIcon).not(currentIcon).hide();

    currentText.show();
    currentIcon.fadeIn(200);

    let currentWidth = currentText.find(settings.rotatorSpan).width();
    currentText.find(settings.rotatorSVG).width(currentWidth);
  };

  return { init };
})();

const aboutImageWrapper = (function () {
  const settings = {
    imageWrapper: "[data-about-image-wrapper]",
    images: "[data-about-image-wrapper] li",
  };

  let mainBox = {};

  const init = function () {
    settings.length = $(settings.imageWrapper).length;

    if (settings.length) {
      mainBox = $(settings.imageWrapper)[0].getBoundingClientRect();

      $(settings.imageWrapper).on("mousemove", handleMouseMovement);
    }
  };

  const handleMouseMovement = function (e) {
    let posX = e.clientX;
    let posY = e.clientY;

    let offsetX = (posX - mainBox.left) / mainBox.width;
    let offsetY = posY / mainBox.height;
  };

  return { init };
})();

$(document).ready(function () {
  triggerAnimations();
  homepageVideoSync.init();
  article.init();
  textRotator.init();
});
